<template>
  <div id="app" :class="theme" @touchstart = "touchStartFun" @touchmove="touchMoveFun" @touchend="touchEndFun" v-wechat-title="$route.meta.title= pageTitle">
    <div class="contianer" @click="contianerClick" v-if="JSON.stringify(allData) != '{}'" >
      <!-- 视频入口 -->
      <div class="videoEntrance" v-if="videoStatusEntrance" >
        <div class="videoEntrance_box">
          <span class="videoEntrance_box_text">{{detail_text}}</span>
          <img class="" src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/videoExit.png" alt="视频入口" @click="videoClick">

          <img class="video_close" src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/videoExitClose.png" alt="关闭" @click="closeVideoClick">
        </div>
      </div>
      
      <!-- 总的购物车数量 -->
      <div
        class="totalShopping"
        v-if="JSON.stringify(shoppingCatList) != '{}' && shoppingCatList.cart_is_show == 1"
        
      >
        <!-- 非自定义 -->
        <img
          style="transform:scale(1.6)"
          v-if="shoppingCatList.selfDefined == 0"
          :src="shoppingCatList.cart_url"
          alt="购物车"
        />
        <!-- 自定义 -->
        <img style="border-radius:50%;overflow:hidden;box-shadow:0 0.05rem 0.25rem 0 rgba(80,80,80,0.16)" v-if="shoppingCatList.selfDefined == 1" :src="shoppingCatList.cart_url" alt="购物车" />
        <div
          class="shoppingNumber"
          v-if="parseInt(shoppingCatList.shopProCount) > 0"
          :style="{background: allData.foot_info.button_info.cart_num_back_color + ' !important',color:allData.foot_info.button_info.cart_num_text_color + ' !important'}"
        >{{ shoppingCatList.shopProCount }}</div>

        <!-- 点击区域 -->
        <div class="activeArea" @click.stop="goShopping"></div>
      </div>
      <!-- 向上的箭头 -->
      <div class="uptop" @click="backShopp(0)" v-if="topDistance">
        <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/gotop.png" alt="回到顶部" />
      </div>

      <!-- 关闭视频的按钮 -->
      <div class="closeVideoBtn" @click="closeVideoClick" v-if="!videoStatus && pro_mp4!=''">
        <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/close.png" alt="关闭" />
      </div>
      <!-- 返回按钮 -->
      <div class="back_page" @click="backPage" v-else>
        <div class="back_page_box">
          <div class="back_page_arrow"></div>
        </div>
      </div>

      <!-- 菜单按钮 -->
      <div class="share_page">
        <div class="back_page_box" @click.stop="changeMenu">
          <div class="menuBox" v-show="flgMenu">
            <!-- 小三角 -->
            <div class="back_page_boxTriangle" v-if="menuList.length"></div>
            <!-- 菜单 -->
            <div class="menu" @click.stop>
              <ul>
                <li
                  v-for="(itemMenu,indexMenu) in menuList"
                  :key="indexMenu"
                  @click.stop="fenxiangClick(itemMenu.link,itemMenu.icon_type) "
                >
                  <div class="menu_div">
                    <img
                      v-if="itemMenu.icon_type == 1"
                      src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/home.png"
                      :alt="itemMenu.name"
                      style="width:0.35rem;height:0.35rem"
                    />
                    <img
                      v-if="itemMenu.icon_type == 2"
                      src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/shoppingCat.png"
                      :alt="itemMenu.name"
                      style="width:0.33rem;height:0.36rem"
                    />
                    <img
                      v-if="itemMenu.icon_type == 3"
                      src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/person.png"
                      :alt="itemMenu.name"
                      style="width:0.29rem;height:0.35rem"
                    />
                    <img
                      v-if="itemMenu.icon_type == 4 "
                      src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/share2.png"
                      :alt="itemMenu.name"
                      style="width:0.4rem;height:0.4rem"
                    />
                    <!-- 收藏(3表示未登录) -->
                    <img
                      v-if="itemMenu.icon_type == 5 && (itemMenu.collect_status == 1 || itemMenu.collect_status == 3)"
                      src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/collection.png"
                      :alt="itemMenu.name"
                      style="width:0.35rem;height:0.35rem"
                    />
                    <!-- 已收藏 -->
                    <img
                      v-if="itemMenu.icon_type == 5 && itemMenu.collect_status == 2"
                      src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/collection2.png"
                      :alt="itemMenu.name"
                      style="width:0.35rem;height:0.35rem"
                    />
                  </div>

                  <span v-html="itemMenu.name"></span>
                </li>
              </ul>
            </div>
          </div>

          <!-- 三个小圆点 -->
          <div class="share_page_arrow">
            <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/ellipsisMenu.png" alt="省略号" />
          </div>
        </div>
      </div>

      <!-- 顶部菜单导航 -->
      <div class="voerTop_menu" :style="{ opacity: flgOpacity }" v-show="flgOpacity">
        <!-- 左边返回 -->
        <div class="voerTop_menuLeft" @click="backPage">
          <span></span>
        </div>
        <!-- 中间导航 -->
        <div class="voerTop_menuCenter">
          <span
            v-for="(itemHead,i) in allData.head_info"
            :key="i"
            :class="{ topOn: topText == i  }"
            @click.stop="backShopp(i,'/evaluation')"
          >{{itemHead}}</span>
        </div>
        <!-- 右侧省略号 -->
        <div class="voerTop_menuRight" @click.stop="changeMenu">
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/ellipsisMenu2.png" alt="省略号" />
        </div>
      </div>

      <!-- 详情规格参数导航 -->
      <!-- <div class="params_detailTitleFied" v-show="topFixed">
        <div class="params_detailTitle_box" >
          <div
            :class="window_width>box_width ? 'params_detailTitle' : 'params_detailTitle_between' "
            ref="params_detailTitle_box_id"
          >
            <span
              v-for="( itemIfication,indexIfication ) in allData.pro_contents"
              :key="indexIfication"
              :class="{ on: indexFlg == indexIfication }"
              @click="changeTitle(indexIfication, itemIfication.type)"
            >{{itemIfication.title}}</span>
          </div>
        </div>
      </div> -->

      <!-- 顶部轮播/视频/图片 -->
      <div class="contianer_top">
        <div class="contianer_content">
          <!-- 播放器 -->
          <div
            :class=" allData.JsonTime == undefined ? 'video_btn' : 'video_btn video_btnMove'"
            @click="playVideo()"
            v-if=" videoStatus "
          >
            <div class="video_btn_left">
              <div class="video_btn_leftBox"></div>
            </div>
            <div class="video_btn_time">
              <span>{{ video_minute }}'{{ video_second }}''</span>
            </div>
          </div>

          <!-- 视频 -->
          <div class="swiperVideo" v-if="pro_mp4!='' && !videoStatus">
            <video ref="videoPlay" id="videoPlay" :src="pro_mp4" controls>
              <!-- <source src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/test2.mp4" type="video/mp4" /> -->
              <!-- <source src="movie.ogg" type="video/ogg"> -->
            </video>
          </div>

          <!-- 限时购 ,微团购-->
          <div
            :class=" activity_state ==  1 || activity_state ==  0 ? 'group_buying' : 'group_buying group_buyingEnd'"
            v-if=" activity_state ==  1 || activity_state ==  0 || activity_state ==  2 "
          >
            <!-- logo -->
            <div class="group_buyingImg">
              <img
                style="width:0.62rem;height:0.3rem"
                src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/groupBuying2.png"
                alt="微团购"
                v-if="flgSatausGou == 1"
              />
              <img
                style="width:0.96rem;height:0.3rem"
                src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/groupBuying.png"
                alt="限时购"
                v-if="flgSatausGou == 0"
              />
            </div>
            <!-- 价格 -->
            <div class="group_buyingPrice">
              <div class="group_PriceBefore" v-if="allData.pro_price_show == 1">
                <span v-html="allData.currency_symbol"></span>
                {{ allData.pro_price }}
                <!-- <span>00</span> -->
              </div>
              <div class="group_PriceAfter" v-if="allData.market_price_show == 1">
                <span v-html="allData.currency_symbol"></span>
                {{ allData.pro_market_price }}
              </div>
            </div>

            <!-- 开始状态、倒计时、结束状态 -->
            <div class="group_buyingStatus" v-if=" activity_state ==  1 || activity_state ==  0">
              <!-- 即将开始 -->
              <div class="group_buyingStart" v-if=" activity_state ==  1 ">
                <span>{{allData.huodongjijiangkaishi}}</span>
              </div>

              <!-- 活动截止时间 -->
              <div class="group_buyingAsTime" v-if="activity_state ==  0">
                <div class="shoppingMain_timeText" v-if="flgSatausGou == 1">
                  <div>
                    <span v-text="allData.huodongjiezhizhi"></span>
                  </div>
                  <div>
                    <span
                      v-text="parseInt(end_time.slice(5,7)) < 10 ? end_time.slice(6,7) : end_time.slice(5,7)"
                    ></span>-<span v-text="parseInt(end_time.slice(8,10)) < 10 ? end_time.slice(9,10) : end_time.slice(8,10)"></span>
                    
                    <span v-text="end_time.slice(11,16)"></span><span>{{ allData.shi }}</span>
                  </div>
                </div>
                <!-- 倒计时 -->
                <div class="group_buyingCountdown" v-if="flgSatausGou == 0">
                  {{ allData.jujieshu }}
                  <span
                    class="shoppingMain_timeDate"
                    v-if="allData.JsonTime.days != 0"
                    v-text="allData.JsonTime.days < 10 ? '0'+allData.JsonTime.days : allData.JsonTime.days"
                  ></span> :
                  <span
                    class="shoppingMain_timeDate"
                    v-text="allData.JsonTime.hours < 10 ? '0'+allData.JsonTime.hours : allData.JsonTime.hours "
                  ></span> :
                  <span
                    class="shoppingMain_timeDate"
                    v-text="allData.JsonTime.minutes<10 ?'0'+allData.JsonTime.minutes : allData.JsonTime.minutes"
                  ></span> :
                  <span
                    class="shoppingMain_timeDate"
                    v-text="allData.JsonTime.seconds<10 ? '0'+allData.JsonTime.seconds : allData.JsonTime.seconds"
                  >{{ allData.JsonTime.seconds }}</span>
                </div>
              </div>
            </div>

            <!-- 已结束 -->
            <div class="group_buyingStatus" v-if="activity_state ==  2">
              <!-- 活动已结束 -->
              <div class="group_buyingStart">
                <span>{{allData.huodongyijieshu}}</span>
              </div>
            </div>
          </div>
          <!-- 一张图片 -->
          <div class="swiperPic" v-if="allData.pro_pic_info.length == 1">
            <img
              :src="allData.conver_origina[0]"
              alt="单个图片"
              preview="1"
              :large="allData.pro_pic_info[0]"
            />
            
             <!-- <img
              :src="allData.conver_origina[0]"
              alt="单个图片"
              preview="1"
              :large="allData.conver_origina[0]"
              @click="openImg(pro_pic_info[0])"
            /> -->
          </div>
          <!-- 轮播图 -->
          <swiper :options="swiperOption" ref="mySwiper" v-else>
          <!-- <swiper :options="swiperOption" ref="mySwiper" v-if="allData.pro_pic_info.length > 1"> -->
            <swiper-slide v-for="(itemLunbo,indexLunbo) in allData.conver_origina" :key="indexLunbo" class="swiperPic">
              <!-- <img :src="itemLunbo" :large="itemBigLunbo" alt="轮播图片" @click="swiperClick(indexLunbo)" /> -->
              <img :src="itemLunbo" :large="allData.pro_pic_info[indexLunbo]" preview="0" alt="轮播图片" />
            </swiper-slide>
            <!-- 分页器 -->
            <div
              :class=" allData.JsonTime == undefined ? 'swiper-pagination' : 'swiper-pagination swiper-paginationBottom' "
              v-for="(itemLunbo,indexLunbo) in pro_pic_info"
              :key="indexLunbo"
              slot="pagination"
            ></div>
          </swiper>

          
        </div>
      </div>

      <!-- 下部内容区域 -->
      <div class="container_content"  :class="{ paddingBottom : allData.foot_info.button_list.length != 0  }">
        <!-- 价格和标题 -->
        <div class="container_content_top">
          <!-- 价格分享 -->
          <div class="container_content_price">
            <!-- 单独设置的会员价样式 -->
            <div class="container_content_priceLeft" v-if="usernameOne == 'tkrs'">
              <div class="container_content_priceAfter alternative_price" v-if="allData.pro_price_show == 1">
                <div>
                  <span v-html="allData.currency_symbol"></span>{{ allData.pro_market_price }}
                  <span
                    class="small_font"
                    style="color:#999999"
                    v-if="allData.pro_prounit!= ''"
                  ><span v-if="allData.pro_prounit.indexOf('/')==-1">/</span>{{ allData.pro_prounit }}</span>
                </div>
              </div>
              <div class="alternative" v-if="allData.market_price_show == 1"  @click.stop="proTagCLick()">
                  <div class="alternative_left">
                    <span>{{ levelValue }}</span>
                  </div>
                  <div class="alternative_right">
                    <span v-html="allData.currency_symbol"></span>
                    {{ allData.pro_price }}
                  </div>
                  <div class="alternative_mark">
                    <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/queMark2.png" alt="问号" @click.stop="proTagCLick()">
                  </div>
              </div>
            </div>

            <!-- 价格 -->
            <div class="container_content_priceLeft" v-else>
              <div class="container_content_priceAfter" v-if="allData.pro_price_show == 1">
                <div>
                  <span class="small_font" v-html="allData.currency_symbol"></span>{{ allData.pro_price }}
                  <span
                    class="small_font"
                    style="color:#999999"
                    v-if="allData.pro_prounit!= ''"
                  > <span v-if="allData.pro_prounit.indexOf('/')==-1">/</span> {{ allData.pro_prounit}}</span>
                </div>
                <div class="members" v-if="allData.pro_tag != '' && allData.pro_price!= ''" @click="proTagCLick()">{{ allData.pro_tag }}</div>
                <div class="members_mark" v-if="MarkValue && allData.pro_price!= ''">
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/qusMark.png" alt="问号" @click="proTagCLick()">
                </div>
              </div>
              <div class="container_content_priceBefore" v-if="allData.market_price_show == 1">
                <span v-html="allData.currency_symbol"></span>
                {{ allData.pro_market_price }}
              </div>
            </div>
            <!-- 分享 -->
            <div
              class="container_content_priceRight"
              @click="shareClick"
              v-if="allData.open_share == 1"
            >
              <div class="share">
                <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/share.png" alt="分享" />
              </div>
              <div>
                <span class="share_text">{{ allData.fenxiang }}</span>
              </div>
            </div>
          </div>

          <!-- 标题,销量 -->
          <div class="container_content_title">
            <!-- 标题 -->
            <span class="top_title">
              <span
                class="title_status"
                :style="{background:bgcColor}"
                v-if="allData.proprietary_label != ''"
              >{{allData.proprietary_label}}</span>
              <span class="title_text" v-if="allData.pro_name != ''">{{ allData.pro_name }}</span>
            </span>
            <!-- 标签和销量 -->
            <div
              class="tip_number"
            >
              <div class="tip">
                <div v-if="allData.discount_label.length > 0">
                  <span
                    class="preferential"
                    v-for="(itemBiaoqian,indexBiaoqian) in allData.discount_label"
                    :key="indexBiaoqian"
                  >{{ itemBiaoqian }}</span>
                </div>
              </div>
              <div style="flex:none">
                <div class="number" v-if="allData.city_show == 1">{{ allData.city_show_name }}</div>
                <div
                  class="number"
                  v-if="allData.city_show == 0 && allData.sale_show == 1 && allData.sale_num > 0"
                >{{ allData.xiaoliang }}:{{ allData.sale_num }}</div>
              </div>
            </div>
            <!-- 跨境商品 -->
            <div class="cross_border" v-if="allData.overseas_info != ''">
              <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/plane.png" alt="跨境" />
              <span>{{allData.overseas_info}}</span>
            </div>
            <!-- 仅限指定区域参与 -->
            <!-- <div class="cross_borderArea" v-show="true" @click="exclusiveClick">
              <div class="cross_borderArea_left">
                <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/warn.png" alt="指定区域" />
                <span>仅限指定区域</span>
              </div>
              <div class="cross_borderArea_right">
                <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/ellipsis.png" alt="介绍" />
              </div>
            </div>-->

            <!-- 参团人数 -->
            <div class="cross_tuxedoPerson" v-if="allData.person_num > 0">
              <div class="cross_tuxedo_PersonImg">
                <div v-for="(itemPicArr, indexPicArr) in allData.person_pic_arr.slice(0,6)" :key="indexPicArr">
                  <img :src="itemPicArr" alt="头像" />
                </div>
              </div>
              <!--参团人数 -->
              <div class="tuxedoPerson">
                <span>{{ allData.person_num }}</span>
                <span>{{ allData.yicantuan }}</span>
                <!-- <span>参团人数</span> -->
              </div>
            </div>
          </div>
        </div>

        <!-- 满减、批发、专享、限时购 -->
        <div class="wholesale_box" v-if="allData.active_module.length">
          <div
            class="wholesale_box_style"
            v-for="(itemModule,indexModule) in allData.active_module"
            :key="indexModule"
          >
            <div class="wholesale" @click="timeLimit(itemModule)">
              <div class="wholesale_left">{{itemModule.title}}</div>
              <div class="wholesale_center">
                <!--  微团购,参团返现 -->
                <div v-if="itemModule.type== 2 && itemModule.special_type == 1">
                  <div>
                    <span class="price">{{itemModule.tag}}</span>
                    <span class="priceIntroduce" v-html="itemModule.popup_info.name"></span>
                  </div>
                  <!-- 参团返现 -->
                  <div
                    class="wholesale_box_style_fanxian"
                    v-if="itemModule.popup_info_add.rule_list.length"
                  >
                    <span class="price">{{itemModule.popup_info_add.name}}</span>
                    <span
                      class="priceIntroduce"
                      v-if="itemModule.popup_info_add.rule_list.length"
                      v-html="itemModule.popup_info_add.rule_list[0]"
                    ></span>
                  </div>
                </div>

                <!-- 会员价 , 限时购-->
                <div
                  v-else-if="itemModule.type== 2 && (itemModule.special_type == 4 || itemModule.special_type == 5)"
                >
                  <span class="price">{{itemModule.tag}}</span>
                  <span class="priceIntroduce" v-html="itemModule.popup_info.name"></span>
                </div>

                <div v-else-if="itemModule.special_type == 7 && itemModule.popup_info != undefined">
                  <span class="price">{{itemModule.tag}}</span>
                  <span class="priceIntroduce" v-html="itemModule.popup_info.name "></span>
                </div>

                <div v-else>
                  <span class="price">{{itemModule.tag}}</span>
                  <span class="priceIntroduce" v-html="itemModule.info"></span>
                </div>
              </div>
              <img class="wholesale_right" src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/ellipsis.png" alt="省略号" />
            </div>
          </div>
        </div>

        <!-- 限时,领券,优惠,规格 -->
        <div style="margin-bottom:0.2rem">
          <div class="preferential_box">
            <!-- 领券,优惠,规格 -->
            <div
              class="preferential_style"
              @click.stop="vouchersClick(itemModule.param)"
              v-for="(itemModule,indexModule) in allData.discount_module"
              :key="indexModule"
            >
              <!-- 领券 -->
              <div class="preferential_text" v-if="itemModule.type == 1">
                <div class="vouchers vouchersPreferential">
                  <span>{{itemModule.title}}</span>
                </div>
                <div class="preferential">
                  <span
                    v-for="(itemModuleInfo,indexModuleInfo) in itemModule.info"
                    :key="indexModuleInfo"
                  >{{itemModuleInfo}}</span>
                </div>

                <div class="specifications" style="padding-top:0;">
                  <span>{{allData.gengduo}}</span>
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/right.png" alt="省略号" />
                </div>
              </div>
              <!-- 优惠 -->
              <div
                class="preferential_text_newline"
                v-if="itemModule.type == 2"
                @click.stop="speciClick(itemModule)"
              >
                <div class="vouchers vouchersTime">
                  <span>{{itemModule.title}}</span>
                </div>
                <div class="preferential_newline_father">
                  <div class="preferential">
                    <div
                      class="preferential_newline_box"
                      v-for="(itemModulePre,indexModulePre) in itemModule.info"
                      :key="indexModulePre"
                    >
                      <div
                        class="preferential_newline"
                        v-if="indexModulePre<3"
                        :class="{ marginBottom: itemModule.info.length == 0}"
                      >
                        <span class="preferential_top" v-html="itemModulePre.title"></span>
                        <span class="preferential_bottom" v-html="itemModulePre.text"></span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="specifications speciEllipsis">
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/ellipsis.png" alt="省略号" />
                </div>
              </div>

              <!-- 规格 -->
              <div
                @click.stop="preferentialClick(allData.pro_id,allData.param_id,2)"
                v-if="allData.param_id > 0 && itemModule.type == 3 "
              >
                <div class="preferential_text preferentialCenter">
                  <div class="vouchers">
                    <span>{{ itemModule.title }}</span>
                  </div>
                  <div class="specifications_box">
                    <!-- <span v-html="itemModule.param_name_info.join('')"></span> -->
                    <span
                      v-for="(itemStatus,indexStatus) in itemModule.param_name_info"
                      :key="indexStatus"
                    >{{ itemStatus+ (indexStatus == itemModule.param_name_info.length - 1 ? '': ',')}}</span>
                  </div>
                  <div class="specifications preferentialPadding">
                    <span>{{allData.qingxuanze}}</span>
                    <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/right.png" alt="right" />
                  </div>
                </div>
              </div>
            </div>

            <!-- 服务提示语提示 -->
            <div class="tip_textBox" @click="tipClick" v-if="allData.service_label.length > 0">

              <div v-for="(itemService,indexService) in allData.service_label" :key="indexService" class="tip_text">
                <img :src="itemService.pic" alt="对号" />
                <span>{{ itemService.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!--商品支持门店配送-->
        <div class="product_detail" v-if="allData.store_link != ''">
          <div class="preferential_box">
            <div class="preferential_style" @click="storesClick()">
              <div class="preferential_text preferentialCenter">
                <div class="vouchers">
                  <span>{{ allData.store_title }}</span>
                </div>
                <div class="specifications preferentialPadding">
                  <span>{{allData.chakan}}</span>
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/right.png" alt="省略号" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 产品属性,商品评价-->
        <div
          class="product_detail"
          v-if="allData.pro_params_info.length > 0 || allData.manu_name != '' || allData.manu_logo != ''"
        >
          <div class="preferential_box">
            <!-- 产品属性 -->
            <div class="preferential_style" @click="AttributeClick">
              <div class="preferential_text preferentialCenter">
                <div class="vouchers">
                  <span>{{ allData.shangpinshuxing }}</span>
                </div>
                <div class="specifications preferentialPadding">
                  <span>{{allData.chakanquanbu}}</span>
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/right.png" alt="省略号" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 商品评价 -->
        <div class="product_detail" v-if="allData.is_show_review == 1">
          <div class="preferential_box">
            <div class="preferential_style" @click="switchTo('/evaluation')">
              <div class="preferential_text preferentialCenter">
                <div class="vouchers">
                  <span>{{allData.review_title}}</span>
                </div>
                <div class="specifications preferentialPadding">
                  <span>{{allData.chakanquanbu}}</span>
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/right.png" alt="省略号" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 搭配推荐 -->
        <div class="collocation" v-if="allData.commend_products.length">
          <div class="collocation_title" @click="collcationClick(allData.commend_link)">
            <span>{{ allData.commend_title }}</span>
            <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/right.png" alt="right" />
          </div>
          <div class="collocation_img">
            <div class="collocation_imgBox">
              <div
                class="collocation_imgSrc"
                v-for="(itemProduct,indexProduct) in allData.commend_products"
                :key="indexProduct"
                @click="commendClick(itemProduct.pro_href)"
              >
                <img :src="itemProduct.pro_pic" alt="图片" />
                <span>
                  <span v-html="allData.currency_symbol"></span>
                  {{itemProduct.pro_price}}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 商铺名称 -->
        <div class="shopping_name" v-if=" allData.shop_info.length ">
          <div class="preferential_box">
            <div class="preferential_style">
              <div class="shopping_text">
                <div class="vouchers_img">
                  <img :src="allData.shop_info[0].pic" alt="logo" />
                </div>
                <div class="preferential">
                  <div class="shopping_title">
                    <span>{{ allData.shop_info[0].name }}</span>
                  </div>
                  <div class="shopping_content">
                    <span>{{ allData.shop_info[0].content }}</span>
                  </div>
                </div>
                <div class="specifications_all" @click="allShops">
                  <button>{{allData.shop_info[0].quanbushangpin}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 详情,规格,参数,文章,图册 -->
        <div class="params_detailBox" v-if="allData.pro_contents.length > 0">
          <!-- <div
            v-for="( itemIfication,indexIfication ) in allData.pro_contents"
            :key="indexIfication"
          >-->
          <!-- 标题 -->
          <div class="params_detailTitle_box" >
            <div
              :class="window_width>box_width ? 'params_detailTitle' : 'params_detailTitle_between' "
              id="params_detailTitle"
              ref="params_detailTitle_box_id"
            >
              <span
                v-for="( itemIfication,indexIfication ) in allData.pro_contents"
                :key="indexIfication"
                :class="{ on: indexFlg == indexIfication }"
                @click="changeTitle(indexIfication, itemIfication.type)"
              >{{itemIfication.title}}</span>
            </div>
          </div>

        <!-- 内容 -->
          <div
            :class="indexFlg == indexIfication ? 'params_detailImg' : 'hidden' "
            v-for="( itemIfication,indexIfication ) in allData.pro_contents"
            :key="indexIfication"
          >
            <div v-if="itemIfication.type == 1">
              <div
                class="contentDeatils"
                v-for="(itemContent,indexContent) in itemIfication.content"
                :key="indexContent"
                v-html="itemContent"
              ></div>
              <!--没有数据的时候 -->
              <div class="noArticle" v-if="itemIfication.content == ''">
                <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/emptyArticle.png" alt="暂无数据" />
                <span>{{ allData.zanwushuju }}</span>
              </div>
            </div>
            <div v-if="itemIfication.type == 2 || itemIfication.type == 3">
              <div class="contentDeatils" v-html="itemIfication.content"></div>
              <!--没有数据的时候 -->
              <div class="noArticle" v-if="itemIfication.content == ''">
                <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/emptyArticle.png" alt="暂无数据" />
                <span>{{ allData.zanwushuju }}</span>
              </div>
            </div>
            <!-- 图册 -->
            <div class="atlasBox" v-if="itemIfication.type == 4">
              <div
                class="atlas"
                v-for="(itemAtlas,indexAtlas) in itemIfication.content"
                :key="indexAtlas"
              >
                <div class="atlas_img" @click="atlasClick(itemAtlas.link)">
                  <img :src="itemAtlas.pic" alt="图片" />

                  <div class="atlas_imgNum">
                    <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/atlas.png" alt="图册" />
                    <span>{{itemAtlas.num}}{{ allData.zhang }}</span>
                  </div>
                </div>
                <span class="atlas_name" @click="atlasClick(itemAtlas.link)">{{itemAtlas.name}}</span>
              </div>
              <!--没有数据的时候 -->
              <div class="noArticle" v-if="itemIfication.content == ''">
                <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/emptyArticle.png" alt="暂无数据" />
                <span>{{ allData.zanwushuju }}</span>
              </div>
            </div>
            <!-- 文章 -->
            <div class="allArticle" v-if="itemIfication.type == 5">
              <div class="allArticle_title">
                <span
                  :class="{articleOn: indexProContent == indexPro }"
                  @click="articleLabel(indexProContent,itemProContent.id,indexIfication)"
                  v-for="( itemProContent,indexProContent ) in itemIfication.content "
                  :key="indexProContent"
                >{{itemProContent.name}}</span>
              </div>
              <!-- 内容 -->
              <div v-if="JSON.stringify(doc_list_Json) != '{}'">
                <div v-if="doc_list_Json.doc_list.length >0">
                  <div
                    class="allArticle_content"
                    v-for="(itemDoc,indexDoc) in doc_list_Json.doc_list"
                    :key="indexDoc"
                    @click="docListClick(itemDoc.url)"
                  >
                    <div class="allArticle_contentImg">
                      <img :src="itemDoc.pic" alt="图片" />
                    </div>
                    <div class="allArticle_contentText">
                      <div class="allArticle_contentText_top">
                        <span class="allArticle_titleSecond">{{itemDoc.title}}</span>
                        
                      </div>
                      <div class="allArticle_contentText_bottom">
                        <span class="allArticle_time">{{itemDoc.publish_date}}</span>
                        <span class="allArticle_text">{{ itemDoc.brief }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="viewMoreBtn"
                  v-if="parseInt(doc_list_Json.doc_page) < parseInt(doc_list_Json.doc_cnt)"
                >
                  <button
                    @click="moreData(doc_list_Json.tag_id,doc_list_Json.doc_page)"
                    class="viewMore"
                  >{{ allData.chakangengduo }}</button>
                </div>

                <!--没有数据的时候 -->
                <div class="noArticle" v-if="doc_list_Json.doc_list.length == 0">
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/emptyArticle.png" alt="暂无数据" />
                  <span>{{ allData.zanwushuju }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 相关产品 -->
        <div class="related_product" v-if="allData.related_products.length">
          <div class="related_productTitle">
            <span>{{ allData.related_title }}</span>
          </div>
          <!-- 商品 -->
          <div class="related_productShop">
            <div
              v-for="(itemRelPro,indexRelPro) in allData.related_products"
              :key="indexRelPro"
              class="related_productBox"
              @click="relatedProClick(itemRelPro.pro_href)"
            >
              <img :src="itemRelPro.pro_pic" alt="商品" />
              <div class="related_productSpan">
                <span class="related_productBox_title">{{ itemRelPro.pro_name }}</span>
                <span class="related_productBox_price" v-if="itemRelPro.pro_price != ''">
                  <span v-html="allData.currency_symbol"></span>
                  {{ itemRelPro.pro_price }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部 -->

      <div
        class="shop_footer"
        v-if="allData.foot_info.button_list.length != 0"
      >
        <!-- 首页 -->
        <div class="footer_home">
          <div
            class="footer_home_box"
            v-for="(itemIcon,indexIcon) in allData.foot_info.icon_arr"
            :key="indexIcon"
            @click="iconClick(itemIcon.type,itemIcon.href)"
          >
            <img
              src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/home.png"
              :alt="itemIcon.name"
              v-if="itemIcon.type == 1"
            />
            <img
              src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/share2.png"
              :alt="itemIcon.name"
              v-if="itemIcon.type == 2"
            />
            <img
              src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/collection.png"
              :alt="itemIcon.name"
              v-if="itemIcon.type == 3 && (icon_typeStatus == '收藏' || icon_typeStatus == 'Collect')"
            />
            <img
              src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/collection2.png"
              :alt="itemIcon.name"
              v-if="itemIcon.type == 3 && (icon_typeStatus == '已收藏' || icon_typeStatus =='Collected')"
            />
            <img
              src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/store.png"
              :alt="itemIcon.name"
              v-if="itemIcon.type == 4"
            />
            <span v-if="itemIcon.type != 3" v-html="itemIcon.name"></span>
            <span v-if="itemIcon.type == 3" v-html="icon_typeStatus"></span>
          </div>
        </div>

        <!-- 加入购物车,立即购买,更多-->
        <div class="footer_right" v-if=" JSON.stringify(allData.foot_info) != '{}' ">

          <!-- <div :style=" {width: allData.foot_info.button_list > 1 ? '2rem' : '4rem'} " class="footer_shoppingCat" v-for="(itemBtnList,indexBtnList) in allData.foot_info.button_list" :key="indexBtnList"> -->
          <div class="footer_shoppingCat" v-for="(itemBtnList,indexBtnList) in allData.foot_info.button_list" :key="indexBtnList">
            
            <!-- 不能购买 -->
            <div class="" v-if="itemBtnList.buy_is_click==0 && itemBtnList.mode != 1001 && itemBtnList.mode != 2&& itemBtnList.mode != 3 && itemBtnList.mode != 4 && itemBtnList.mode != 5&& itemBtnList.mode != 6&& itemBtnList.mode != 10">
              <button :style="{background:'#F5F5F5',color:'#555', width:allData.foot_info.button_list.length > 1 ? '2rem':'4.2rem'  }">{{ itemBtnList.name }}</button>
            </div>
            <!-- 可以购买 -->
            <div v-if="itemBtnList.buy_is_click!=0">
              <!-- 加入购物车 -->
              <button
                :style=" {width: allData.foot_info.button_list.length > 1 ? '2rem' : '4rem',background:allData.foot_info.button_info.is_define == 1 ? allData.foot_info.button_info.add_bg + ' !important' : '',color:allData.foot_info.button_info.is_define == 1 ? allData.foot_info.button_info.add_text + ' !important' : '' }"
                style="background-origin:border-box !important"
                class="colorShoppCat"
                v-if="itemBtnList.mode == 1002"
                @click="preferentialClick(allData.pro_id,allData.param_id,itemBtnList.buy_is_click)"

              >{{itemBtnList.name}}</button>

              <!-- 立即购买 -->
              <button
                :style=" {width: allData.foot_info.button_list.length > 1? '2rem' : '4.2rem',background:allData.foot_info.button_info.is_define == 1 ? allData.foot_info.button_info.buy_bg + ' !important' : '',color:allData.foot_info.button_info.is_define == 1 ? allData.foot_info.button_info.buy_text + ' !important' : ''}"
                style="background-origin:border-box !important"
                class="colorBuynow"
                v-if="itemBtnList.mode == 1000"
                @click.stop="immediatelyBuy(itemBtnList.buy_is_click,2)"
              >{{itemBtnList.name}}</button>
            </div>

            <!-- 更多 -->
            <div
              class="footer_moreBuy"
              v-if="itemBtnList.mode == 1001"
              @click.stop="morenState"
              
            >
              <!-- 四个状态 -->
              <div class="fourState" v-show="flgFourState">
                <div class="fourStateBox">
                  <!-- 小三角 -->
                  <div class="fourStateBox_sanjiao"></div>
                  <div
                    class="fourStateBox_span"
                    v-for="(itemMore,indexMore) in allData.foot_info.more_button"
                    :key="indexMore"
                  >
                    <span v-if="itemMore.mode==6" @click.stop="openImg(itemMore.href)">
                      <img
                        style="width:0.37rem;height:0.3rem"
                        src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/weixin_icon.png"
                        alt="link"
                      />
                      <span>{{itemMore.name}}</span>
                    </span>
                    <span v-else>
                      <a :href="itemMore.href">
                        <!-- 外部链接 -->
                        <img
                          src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/link_icon.png"
                          v-if="itemMore.mode == 2"
                          alt="link"
                        />
                        <!-- 电话咨询 -->
                        <img
                          src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/phone_icon.png"
                          alt="link"
                          v-if="itemMore.mode == 3"
                        />
                        <!-- 短信联系 -->
                        <img
                          src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/duanxin.png"
                          v-if="itemMore.mode == 4"
                          alt="link"
                        />
                        <!-- qq -->
                        <img
                          style="width:0.25rem;height:0.31rem"
                          src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/qq_icon.png"
                          v-if="itemMore.mode == 5"
                          alt="link"
                        />

                        <img
                          style="width:0.34rem;height:0.34rem"
                          src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/sms.png"
                          v-if="itemMore.mode == 10"
                          alt="link"
                        />
                      </a>
                      <a :href="itemMore.href">{{ itemMore.name }}</a>
                    </span>
                  </div>
                </div>
              </div>
              <button style="background-origin:border-box !important" :style="{width: allData.foot_info.button_list.length == 1 ? '4rem' : '2rem' }">{{itemBtnList.name}}</button>
            </div>

            <!-- 更多只有一个状态 -->
            <div
              class="footer_moreBuy footer_moreBuy2"
              v-if="itemBtnList.mode != 1000 && itemBtnList.mode != 1001 && itemBtnList.mode != 1002 "
              
            >
              <!-- 外部链接  -->
              <button
                v-if="itemBtnList.mode == 2"
                style="background:linear-gradient(90deg,rgba(33,153,255,1),rgba(96,182,255,1));"
                :style="{width: allData.foot_info.button_list.length == 1 ? '4rem' : '2rem' }"
              >
                <a :href="itemBtnList.href">
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/link_icon2.png" alt="链接" style="width:0.33rem;height:0.32rem"/>
                  {{itemBtnList.name}}
                </a>
              </button>
              <!-- 电话 -->
              <button
                v-if="itemBtnList.mode == 3"
                style="background:linear-gradient(90deg,rgba(33,153,255,1),rgba(96,182,255,1));"
                :style="{width: allData.foot_info.button_list.length == 1 ? '4rem' : '2rem' }"
              >
                <a :href="itemBtnList.href">
                  <img
                    style="width:0.3rem;height:0.3rem"
                    src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/phone_icon2.png"
                    alt="电话"
                  />
                  {{itemBtnList.name}}
                </a>
              </button>
              <!-- 短信联系 -->
              <button
                v-if="itemBtnList.mode == 4"
                style="background:linear-gradient(90deg,rgba(33,153,255,1),rgba(96,182,255,1));"
                :style="{width: allData.foot_info.button_list.length == 1 ? '4rem' : '2rem' }"
              >
                <a :href="itemBtnList.href">
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/duanxin2.png" alt="短信" style="width:0.33rem;height:0.25rem"/>
                  {{itemBtnList.name}}
                </a>
              </button>
              <!-- qq -->
              <button
                v-if="itemBtnList.mode == 5"
                style="background:linear-gradient(90deg,rgba(33,153,255,1),rgba(96,182,255,1));"
                :style="{width: allData.foot_info.button_list.length == 1 ? '4rem' : '2rem' }"
              >
                <a :href="itemBtnList.href">
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/qq_icon2.png" alt="qq" style="width:0.25rem;height:0.31rem"/>
                  {{itemBtnList.name}}
                </a>
              </button>
              <!-- 微信 -->
              <button
                v-if="itemBtnList.mode == 6"
                @click="openImg(itemBtnList.href)"
                style="background:linear-gradient(90deg,rgba(49,195,100,1),rgba(96,202,133,1))"
                :style="{width: allData.foot_info.button_list.length == 1 ? '4rem' : '2rem' }"
              >
                <a href="javascript:">
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/weixin_icon2.png" alt="微信" style="width:0.37rem;height:0.30rem"/>
                  {{itemBtnList.name}}
                </a>
              </button>
              <!-- 站内咨询 -->
              <button
                v-if="itemBtnList.mode == 10"
                style="background:linear-gradient(90deg,rgba(33,153,255,1),rgba(96,182,255,1));"
                :style="{width: allData.foot_info.button_list.length == 1 ? '4rem' : '2rem' }"
              >
                <a :href="itemBtnList.href">
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/sms2.png" alt="站内咨询" style="width:0.34rem;height:0.34rem"/>
                  {{itemBtnList.name}}
                </a>
              </button>
            </div>


          </div>

          <!-- 活动即将开始 -->
          <!-- <div class="footer_activity" v-show="false">
            <button>活动即将开始</button>
          </div>-->
        </div>
      </div>
      <!-- 点击关闭放大蒙版轮播 -->
      <div class="amplification_box" v-if="amplificationFlg">
        <div class="amplification">
          <!-- 轮播图 -->
          <swiper :options="swiperOptionBig" ref="mySwiperBig" class="amplification_swiper">
            <swiper-slide
              v-for="(itemBigLunbo,indexBigLunbo) in pro_pic_info"
              :key="indexBigLunbo"
            >
              <!-- <img :src="itemBigLunbo" preview-text="描述文字" preview="0" alt="轮播图片" @click.stop="swiperClickClose(indexBigLunbo)" /> -->
              <img :src="itemBigLunbo"  alt="轮播图片"/>
              <!-- <img :src="itemBigLunbo"  alt="轮播图片"  /> -->
            </swiper-slide>
          </swiper>
        </div>
      </div>

      <!-- 点击关闭放大蒙版图片 -->
      <div class="amplification_box" v-if="imgFlg" @click="colseImg">
      <!-- <div class="amplification_box"  v-if="imgFlg"> -->
        <div class="amplification">
          <img :src="shopImgSrc" alt="商品图片" />
          <!-- <swiper :options="swiperOptionBig" ref="mySwiperBig">
            <swiper-slide>
              <img :src="shopImgSrc" alt="商品图片" />
            </swiper-slide>
          </swiper> -->
        </div>
      </div>

      <!-- 右上角分享给好友 -->
      <div class="weixinShareBox" v-if="wixinShareStatus" @click="wixinShareStatus = !wixinShareStatus">
        <div class="wx_right">
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/rightArrow.png">
        </div>
        <div class="wx_center">
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/rightText.png">
        </div>
        <div class="wx_bottom">
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/rightBottonText.png">
        </div>
      </div>

      <!-- 分享弹窗 -->
      <CustomPopup ref="Customshare" @fenxiangFun="closeShare">
        <div slot="PoperContent" class="PoperContentView">
          <!-- <div class="ServiceTimeLimit W100">
          </div>-->
          <!-- 分享的图片 -->
          <div class="shareContentText" v-if=" ifFxPic ">
            <div class="shareContent_img" @click="fenxiangDetailClick">
              <div class="shareContent_img_top">
                <img :src="shareJson.propic_url" alt="图片" />
              </div>
              <div class="shareContent_img_bottom">
                <div class="shareContent_img_title" v-if="shareJson.pro_tag_price != '' || shareJson.prounitprice != ''">
                  <span class="symbol" v-html="allData.currency_symbol"></span>
                  <span
                    class="money"
                    v-if="shareJson.pro_tag_price == ''"
                  >{{shareJson.prounitprice}}</span>
                  <span class="money" v-else>{{shareJson.pro_tag_price}}</span>
                  <span class="xianshigou" v-if="shareJson.tag_text != ''">{{shareJson.tag_text}}</span>
                </div>
                <div class="shareContent_title">
                  <span>{{ shareJson.proname }}</span>
                </div>
                <div class="shareContent_preview">
                  <span>{{ shareJson.tag_mag }}</span>
                </div>
              </div>
            </div>

            <div class="shareContentText_top">
              <span>{{shareJson.show_mag}}</span>
            </div>
            <div class="shareContentText_img">
              <!-- <div v-if="winxinIcon" >
                <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/weixin.png" alt="微信" />
                <span>微信</span>
              </div> -->
              <div
                v-for="(itemType,indexType) in shareJson.type"
                :key="indexType"
                @click.stop="operation(itemType.type)"
              >
                <img
                  src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/save.png"
                  v-if="itemType.type == 1"
                  :alt="itemType.typeNote"
                />
                <img
                  src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/link.png"
                  v-if="itemType.type == 2"
                  :alt="itemType.typeNote"
                  v-clipboard:copy="shareJson.share_link"
                  v-clipboard:success="onCopyUrl"
                  v-clipboard:error="onErrorUrl"
                />
                <!--  -->
                <img v-if="itemType.type == 4 && winxinIcon"  @click="wxShareStatus" src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/weixin.png" alt="微信" />
                <!-- 保存图片，复制链接 -->
                <span v-if="itemType.type == 1 || itemType.type == 2">{{ itemType.typeNote }}</span>
                <!-- 分享给好友 -->
                <span v-if="itemType.type == 4 && winxinIcon">{{ itemType.typeNote }}</span>
              </div>
            </div>
          </div>

          <div class="PoperContentBtn cancelBtn" @click="closeShare">{{ allData.quxiao }}</div>
        </div>
      </CustomPopup>

      <!-- 预览图片弹窗 -->
      <CustomPopup ref="CustomshareDetail" @fenxiangDetailFun="closeShareDetail">
        <div
          slot="PoperContent"
          class="PoperContentView FeixiangDeatilView"
          @click="closeShareDetail"
        >
        <div class="shareDetailBox_prompt">
              {{ shareJson.chang_an }}
        </div>
          <div class="shareDetailBox">
            <div class="shareDetailBox_top">
              <img :src="returnUrl" alt="图片" />
            </div>
          </div>
        </div>
      </CustomPopup>

      <!-- 指定区域弹窗 -->
      <CustomPopup ref="CustomExclusive" @zhidingquyuFun="exclusiveBtn">
        <div slot="PoperContent" class="PoperContentView">
          <div class="ServiceExclusive W100">
            <span>团购活动仅支持指定城市</span>
          </div>
          <!-- 支持城市 -->
          <div class="exclusiveContent">
            <div class="exclusiveContent_top">
              <span>仅限以下城市可参加活动：</span>
            </div>
            <div class="exclusiveContent_bottom">
              <span>安徽省阜阳市</span>
              <span>安徽省阜阳市</span>
            </div>
          </div>

          <div class="PoperContentBtn" @click="exclusiveBtn">完成</div>
        </div>
      </CustomPopup>

      <!-- 专享弹窗 -->
      <CustomPopup ref="CustomWholesaleLast" @zhuanxiangFun="closeWholesaleLastClick">
        <div slot="PoperContent" class="PoperContentView">
          <div class="wholesaleTimeLimit W100">
            <div>
              <!-- <div class="timeLimit_reduce">
                  <span>专享</span>
              </div>-->
              <div class="timeLimit_name">
                <span>促销名称促销名称促销名称促销名称促销名称促销名称促销名称促销名称促销名称促销名称</span>
              </div>
            </div>
            <div>
              <span>
                <span class="wholesaleAleady">已选规格：</span> "红色""42.5"
              </span>
            </div>
          </div>
          <!-- 金额满减 -->
          <div class="wholesaleContentText">
            <div>
              <span>购买1-15件时</span>
              <span>每件 ￥999.00</span>
            </div>
            <div>
              <span>购买1-15件时</span>
              <span>每件 ￥999.00</span>
            </div>
          </div>
          <div class="PoperContentBtn" @click="closeWholesaleLastClick">完成</div>
        </div>
      </CustomPopup>

      <!-- 限时弹窗 -->
      <CustomPopup ref="limitTimeAccording" @xianshiFUn="closelimitTimeAccording">
        <div slot="PoperContent" class="PoperContentView">
          <div class="accordingService W100">
            <div class="accordingService_top">
              <div class="timeLimit_reduce">
                <span>限时</span>
              </div>
              <div class="accordingLimitTime">
                <span>促销名称促销名称促销名称促销名称</span>
              </div>
            </div>
            <div class="accordingService_bottom">
              <span>家开通微团购功能,可以发起任意产品的团购活动,整个使用流程跟团购模式一样,不仅留住一次性团购用户,还可以引导二次消费。</span>
            </div>
          </div>
          <!-- 金额满减 -->
          <div class="TipContentText" style="padding-bottom:0.3rem">
            <span>参团返现</span>
            <span>订单金额满1000 减 100订单金额满1000订单金额满1000订单金额满1000订单金额满1000订单金额满1000</span>
            <span>订单金额满1000 减 100</span>
            <span>订单金额满1000 减 100</span>
            <span>订单金额满1000 减 100</span>
          </div>
          <!-- 活动时间 -->
          <div class="TipContentTime">
            <span>活动时间</span>
            <span>2019-11-11 12:00:00 至 2019-11-11 12:00:00</span>
          </div>
          <div class="PoperContentBtn" @click="closelimitTimeAccording">完成</div>
        </div>
      </CustomPopup>

      <!-- 领券弹窗 -->
      <CustomPopup ref="CustomVouchers" @lingquanFun="closeVouchersBtn">
        <div
          slot="PoperContent"
          class="PoperContentView vouchersContentView"
          v-if="JSON.stringify(preferData) != '{}'"
        >
          <div class="ServiceNoteTitle VouchersTitle W100">{{preferData.name}}</div>
          <div class="vouchersContentText ServiceNoteBox">
            <!-- 优惠券 -->
            <div
              class="vouchersDetails"
              v-for="(itemPer,indexPer) in preferData.data[0].info"
              :key="indexPer"
            >
              <div class="vouchersDetails_top">
                <div class="vouchersDetails_price">
                  <span>
                    <span class="vouchersDetails_symbol" v-html="allData.currency_symbol"></span>
                    {{ itemPer.coupon_info.coupon_money }}
                  </span>
                  <span class="vouchersDetails_text">{{preferData.name}}</span>
                </div>
                <div class="vouchersDetails_rules">
                  <span>{{ preferData.use_rule }}：</span>
                  <span v-html="itemPer.coupon_info.rule_info"></span>
                </div>

                <!-- 未登录 -->
                <div class="vouchersDetails_btn" v-if="zz_userid == 0">
                  <button
                    @click="qujiesuanClick()"
                    class="vouchersDetailsBtn"
                  >{{preferData.likelingqu}}</button>
                </div>

                <div class="vouchersDetails_btn" v-else>
                  <button
                    @click="receiveClick(itemPer.coupon_info.id)"
                    class="vouchersDetailsBtn"
                    v-if="itemPer.coupon_info.receive == 0"
                  >{{preferData.likelingqu}}</button>
                  <button
                    class="vouchersAlearyBtn"
                    v-if="itemPer.coupon_info.receive == 1"
                  >{{preferData.yilingqu}}</button>
                </div>
              </div>

              <div class="vouchersDetails_bottom">
                <div v-if="itemPer.coupon_info.receive_info != ''">
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/warn.png" alt="“tip" />
                  <span>{{itemPer.coupon_info.receive_info}}</span>
                </div>
                <div>
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/time.png" alt="“tip" />
                  <span
                    class="bottomTime"
                  >{{preferData.period_of_validity}}:{{itemPer.coupon_info.start_time.slice(0,11)}} {{preferData.zhi}} {{itemPer.coupon_info.end_time.slice(0,11)}}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="PoperContentBtn"
            @click="closeVouchersBtn"
          >{{ allData.wancheng }}</div>
        </div>
      </CustomPopup>

      <!-- 优惠弹窗 -->
      <CustomPopup ref="CustomPopupRef" @youhuiFun="closerButton">
        <div
          slot="PoperContent"
          class="PoperContentView"
          v-if="JSON.stringify(preferentialPop) != '{}'"
        >
          <div class="ServiceNoteTitle W100">{{ preferentialPop.title }}</div>
          <div class="PoperContentText">
            <div v-for="(itemPop,indexPop) in  preferentialPop.info" :key="indexPop">
              <span class="PoperContentText_left" v-html="itemPop.title"></span>
              <span class="PoperContentText_right" v-html="itemPop.text"></span>
            </div>
          </div>
          <div class="PoperContentBtn" @click="closerButton">{{allData.wancheng}}</div>
        </div>
      </CustomPopup>

      <!-- 规格弹窗 -->
      <CustomPopup ref="shoppingStatus" @guigeFun="closeShoppingStatusBtn">
        <div
          slot="PoperContent"
          class="PoperContentView shoppingStatusView"
          v-if="JSON.stringify(guigeData) != '{}'"
          :style="{paddingBottom: guigeData.is_show_button_info == 1 && allData.foot_info.button_list.length != 0 ? '' : 0 }"
        >
          <!-- 顶部商品信息价格 -->
          <div class="shoppingStatus_top">
            <!-- 顶部商品图片 -->
            <!-- <div class="shoppingStatus_topImg" @click="openImg(guigeData.pro_pic)"> -->
            <div class="shoppingStatus_topImg">
              <img :src="guigeData.pro_pic" :large="guigeData.pro_pic" preview="3" alt="图片" />
            </div>

            <!-- 顶部规格 -->
            <div class="shoppingStatus_topStatus" v-if="guigeTopFlg">
              <div class="shoppingStatus_topPrice">
                <div class="shoppingStatus_PriceBox" v-if="allData.pro_price_show == 1">
                  <!-- 原价 -->
                  <span
                    v-if="(guigeData.pro_original_price_show  > 0 || guigeData.pro_original_price_show != '') && (guigeData.pro_original_price_show != guigeData.pro_price)"
                  >
                    <span v-html="allData.currency_symbol" style="font-size:0.28rem"></span>
                    <em>{{ guigeData.pro_original_price_show }}</em>
                    <!-- <em>139.</em>00 -->
                  </span>
                  <!-- 折扣价 -->
                  <div
                    class="shoppingStatus_topReduction"
                    v-if="guigeData.pro_price != '' && guigeData.pro_price != guigeData.pro_original_price_show"
                  >
                    <!-- 原价为空 -->
                    <span
                      v-if="guigeData.pro_original_price_show == '' || guigeData.pro_original_price_show  == 0"
                      style="color: #F0250F !important;font-size: 0.34rem !important;"
                    >
                      <span v-html="allData.currency_symbol"></span>
                      <span>{{ guigeData.pro_price_show }}</span>
                    </span>
                    <!-- 原价不为空 -->
                    <span v-else>
                      <span v-html="allData.currency_symbol" style="color:#111"></span>
                      {{ guigeData.pro_price_show }}
                    </span>

                    <div class="status_thrid" v-if="guigeData.pro_tag!= ''">
                      <div
                        class="status_thrid_box"
                        v-if="guigeData.pro_tag == '会员价' || guigeData.pro_tag == '会员折扣'"
                      >
                        <span>{{ guigeData.pro_tag }}</span>
                      </div>
                      <div class="status_thrid_box2" v-else>
                        <span>{{ guigeData.pro_tag }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <span
                  v-if="guigeData.jifen_must_num > 0"
                >{{ guigeData.laguage_info.bixushiyong }}{{ guigeData.jifen_must_num }}{{ guigeData.xf_name }}</span>
              </div>
              <div
                v-if="(guigeName != undefined || guigeName!= '' || guigeName!= null) && guigeData.spec_info.length "
              >
                <span>
                  {{ guigeData.laguage_info.yixuan }}：
                  <em
                    v-for="(itemName,indexName) in guigeName"
                    :key="indexName"
                  >{{ '"' + itemName+ '"'}}&nbsp;&nbsp;</em>
                </span>
              </div>
            </div>

            <!-- 关闭按钮 -->
            <div class="shoppingStatus_colseBtn" @click="closeShoppingStatusBtn">
              <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/close.png" alt="关闭" />
            </div>
          </div>

          <!-- 下部规格部分 -->
          <div class="shoppingStatus_infos">
            <!-- 规格选择,购买数量等 -->
            <div class="shoppingStatus_infosBox">
              <!-- 规格选择 -->
              <div class="shoppingStatus_colorSize" v-if="guigeData.spec_info.length">
                <div
                  class="shoppingStatus_infosColor"
                  v-for="(itemSpec,indexSpec) in guigeData.spec_info"
                  :key="indexSpec"
                >
                  <div class="shoppingStatus_colorTitle">
                    <span>{{itemSpec.name}}</span>
                  </div>
                  <div class="shoppingStatus_colorValue">
                    <span
                      :class="(itemSpecSecond.is_default == 1) ? 'activeColor' : '' "
                      @click=" changColorClick(indexSpec,indexSPecSecond) "
                      v-for="(itemSpecSecond,indexSPecSecond) in itemSpec.spec"
                      :key="indexSPecSecond"
                    >{{ itemSpecSecond.name }}</span>
                  </div>
                </div>
              </div>

              <!-- 购买数量 -->
              <div v-if="guigeData.is_show_button_info == 1">

              
              <div class="shoppingStatus_infosNumbers" v-if="guigeData.phone_info.length == 0">
                <em>{{ guigeData.laguage_info.goumaishuliang }}</em>
                <div class="shoppingStatus_numbersChange">
                  <span
                    v-if="guigeData.pro_small >1 && guigeData.is_specia_wholesale != 1"
                  >{{guigeData.pro_small}}{{guigeData.laguage_info.meijian}}{{guigeData.laguage_info.qishou}}</span>
                  <span
                    v-if="guigeData.pro_small >1 && restrict_num > 0 && guigeData.is_specia_wholesale != 1"
                  >&nbsp;&nbsp;</span>
                  <span
                    v-if="restrict_num > 0 && guigeData.is_specia_wholesale != 1"
                  >{{guigeData.laguage_info.xiangou}}{{ restrict_num }}{{guigeData.laguage_info.meijian}}</span>

                  <div class="shoppingStatus_numbersChangeBox">
                    <span class="reduce" @click.stop="reduceBuyNumbers">—</span>
                    <input
                      type="number"
                      v-model="changeNumbers"
                      v-on:input="numberInput"
                      @blur="numberBlur"
                    />
                    <span class="add" @click.stop="addBuyNumbers">+</span>
                  </div>
                </div>
              </div>
              </div>
            </div>
            <!-- 未选手机号 -->
            <div
              class="shoppingStatus_Nophone"
              v-if=" phoneValue == 0 && guigeData.phone_info.length > 0"
            >
              <span>{{guigeData.laguage_info.qingxuanze}}{{guigeData.laguage_info.shoujihao}}</span>
              <button @click="changePhone">{{ guigeData.laguage_info.lijixuanhao }}</button>
            </div>

            <!-- 已选手机号 -->
            <div class="shoppingStatus_Yesphone" v-show=" phoneValue == 1 ">
              <span>{{guigeData.laguage_info.yixuan}}{{guigeData.laguage_info.shoujihao}}:</span>
              <div class="shoppingStatus_changePhone">
                <span class="shoppingStatus_Phone">{{ myPhone }}</span>
                <em @click="changePhone">{{guigeData.laguage_info.genghuan}}</em>
              </div>
            </div>
            <!-- 批发商品 -->
            <div
              class="shoppingStatus_infosWholesale"
              v-if="guigeData.wholesale_info.length && guigeData.pro_type == 5"
            >
              <span>{{guigeData.laguage_info.pifa}}</span>
              <div class="shoppingStatus_wholesaleBox">
                <span v-for="(itemShop,indexShop) in guigeData.wholesale_info" :key="indexShop">
                  <em v-if="indexShop == 0">
                    {{ guigeData.laguage_info.man }}{{ itemShop.split('_')[0] }}{{guigeData.laguage_info.meijian}}
                    <span
                      style="padding:0"
                      v-html="guigeData.currency_symbol"
                    ></span>{{itemShop.split('_')[1]}}/{{guigeData.laguage_info.meijian}}
                  </em>
                  <em v-else>
                    {{ guigeData.laguage_info.man }}{{ parseInt(itemShop.split('_')[0]) + 1 }}{{guigeData.laguage_info.meijian}}
                    <span
                      style="padding:0"
                      v-html="guigeData.currency_symbol"
                    ></span>{{itemShop.split('_')[1]}}/{{guigeData.laguage_info.meijian}}
                  </em>
                </span>
              </div>
            </div>
          </div>

        <div v-if="guigeData.is_show_button_info == 1 && allData.foot_info.button_list.length != 0">
          <div
            class="shoppingNoPopup"
            v-if="ifBuy == 0 || (phone_infoFlg == 0 && ifBuy == 1 && guigeData.phone_info.length > 0)"
          >
            <span
              v-if="phone_infoFlg == 0 && ifBuy == 1 && guigeData.phone_info.length > 0"
            >{{guigeData.button_info.buy_define_name}}</span>
            <span  v-else>{{ err_msg }}</span>
          </div>

          <div
            class="shoppingChangeBtn"
            :class="{ shoppingChangeBtn : guigeData.is_show_buy != 0 && guigeData.is_show_add != 0 && guigeData.is_specia_wholesale != '1'}"
            v-show="(ifBuy == 1 && phone_infoFlg == 1 && guigeData.phone_info.length > 0 && guigeData.is_show_buy == 1  ) || (ifBuy == 1&& guigeData.phone_info.length == 0) "
          >
            <!-- 加入购物车 -->
            <div
              :class="{shoppingStatusPopup2 : guigeData.is_show_buy == 0 || guigeData.is_specia_wholesale == '1'}"
              @click="joinShoppCat"
              v-show="guigeData.is_show_add == 1"
            >{{ guigeData.button_info.add_define_name }}</div>
            <!-- 立即购买 -->
            <div
              :class="{shoppingStatusPopup : guigeData.is_show_add == 0 || guigeData.phone_info.length > 0}"
              @click="immediatelyBuy(0,1)"
              v-if="guigeData.is_show_buy == 1 && guigeData.is_specia_wholesale != '1'"
            >{{ guigeData.button_info.buy_define_name }}</div>
          </div>
          </div>
        </div>
      </CustomPopup>

      <!-- 选择手机号弹窗 -->
      <CustomPopup ref="CustomChangePhone">
        <div
          slot="PoperContentFull"
          class="changePhoneBox"
          v-if="JSON.stringify(guigeData) != '{}'"
        >
          <!-- 标题 -->
          <div class="contentFullTitle">
            <span>{{guigeData.laguage_info.qingxuanze}}{{guigeData.laguage_info.shoujihao}}</span>
            <!-- 关闭按钮 -->
            <div class="closeContentFull" @click="colseChangePhone()">
              <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/close2.png" alt="关闭" />
            </div>
          </div>
          <!-- <div class="contentFullTitle">
              <input type="text" placeholder="请输入" v-model="phoneModel" />
            
          </div> -->
          <!-- 搜索 -->
          <div class="contentFull_search">
            <div class="contentFull_searchInput">
              <input type="text" placeholder="请输入" v-model="phoneModel" />
              <img @click="seachPhone" src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/search.png" alt="搜索" />
            </div>
          </div>
          <div class="phoneBoxList_box">

          <!-- 手机号 -->
          <div class="phoneBoxList" v-if="phone_info_arr.length">

            <div
              :class=" indexClass == indexPhone ? 'phoneBoxActive phoneBox' : 'phoneBox' "
              v-for="(itemPhone,indexPhone) in phone_info_arr"
              :key="indexPhone"
              @click="phoneCick(indexPhone,itemPhone.id)"
            >
              <span :style="{color: itemPhone.use == 1 ? '#ededed !important' : '#333333'}">{{ itemPhone.phone }}</span>
              <span :class="indexClass == indexPhone ? 'selectedActive' : ''"></span>
            </div>
            </div>
          

          <!-- 无手机号样式 -->
          <div class="phoneBoxList_no" v-if="phone_info_arr.length == 0">
            <span>{{guigeData.laguage_info.zanwushuju}}</span>
          </div>
          </div>

          <div class="phoneBoxBtn" @click="colseChangePhone()">
            <button>{{ allData.queren }}</button>
          </div>
        </div>
      </CustomPopup>

      <!-- 服务弹窗 -->
      <CustomPopup ref="CustomTipRef" @fuwuFun="closerTipBtn">
        <div slot="PoperContent" class="PoperContentView">
          <div class="ServiceNoteTitle W100">{{ allData.fuwu }}</div>
          <div class="TipContentText fuwuTipContent">
            <div v-for="(itemService,indexService) in allData.service_label" :key="indexService">
              <img :src="itemService.pic" alt="对号" />
              <span>{{ itemService.name }}</span>
            </div>
          </div>
          <div class="PoperContentBtn" @click="closerTipBtn">{{ allData.wancheng }}</div>
        </div>
      </CustomPopup>

      <!-- 产品属性弹窗 -->
      <CustomPopup ref="CustomAttributeRef" @canpinshuxiangFun="closerAttributeBtn">
        <div slot="PoperContent" class="PoperContentView">
          <div class="ServiceNoteBox">
            <div class="ServiceNoteTitle W100">{{allData.shangpinshuxing}}</div>
            <div class="attributeContentText">
              <div
                class="attributeContentText_top"
                v-if="allData.manu_name != '' && allData.manu_logo != ''"
              >
                <img :src="allData.manu_logo" alt="logo" />
                <span>{{ allData.manu_name }}</span>
              </div>
              <div class="attributeContentText_bottom" v-if="allData.pro_params_info.length > 0">
                <div v-for="( itemInfo,indexInfo ) in allData.pro_params_info " :key="indexInfo">
                  <span>{{ itemInfo.name }}</span>
                  <span>{{ itemInfo.value }}</span>
                </div>
                <!-- <div>
                <span>频响范围</span>
                <span>Momentum True Wireless</span>
                </div>-->
              </div>
            </div>
          </div>

          <div class="PoperContentBtn" @click="closerAttributeBtn">{{ allData.wancheng }}</div>
        </div>
      </CustomPopup>

      <!-- 满减,限时购,弹窗 -->
      <CustomPopup ref="CustomTimeLimit" @closeManjian="closeTimeLimitBtn">
        <div slot="PoperContent" class="PoperContentView manjianXsg">
          <section
            class="maxHeight"
            v-for="(itemManPop,indexManPop) in manjianArray"
            :key="indexManPop"
          >
            <div class="ServiceTimeLimitBox">
              <div class="ServiceTimeLimit W100">
                <div
                  class="timeLimit_reduce"
                  v-if="itemManPop.tag !='' && itemManPop.special_type != 7"
                >
                  <span v-html="itemManPop.tag"></span>
                </div>
                <div class="timeLimit_name" v-if="itemManPop.popup_info.name!= ''">
                  <span v-html="itemManPop.popup_info.name"></span>
                </div>

                <div
                  class="timeLimit_more"
                  v-if="gengduokeyongshangpin != '' && itemManPop.type == 1"
                  @click="switchToPage(itemManPop.link) "
                >
                  <span>{{gengduokeyongshangpin}}</span>
                  <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/right.png" alt="right" />
                </div>
              </div>
              <!-- 微团购 -->
              <div
                class="ServiceTimeLimitBox_info"
                v-if="JSON.stringify(itemManPop.popup_info) != '{}' && itemManPop.type == 2 && itemManPop.special_type == 1"
              >
                <span v-html="itemManPop.popup_info.info"></span>
              </div>

              <!-- 会员价,批发 -->
              <div
                class="ServiceTimeLimitBox_yixuan"
                v-if="JSON.stringify(itemManPop.popup_info) != '{}' && itemManPop.type == 2 && (itemManPop.special_type == 7 || itemManPop.special_type == 5)  && guigeNameHY.length"
              >
                <span>{{allData.yixuan}} :</span>&nbsp;&nbsp;
                <span
                  v-for="(itemYixuan,indexYixuan) in guigeNameHY"
                  :key="indexYixuan"
                >{{ '"'+ itemYixuan + '"'}}</span>
              </div>
            </div>

            <!-- 金额满减 -->
            <div
              class="TipContentText2"
              v-if="JSON.stringify(itemManPop.popup_info) != '{}' && itemManPop.popup_info.rule_list.length && itemManPop.type == 1"
            >
              <span
                v-for="(itemManjian,indexManjian) in itemManPop.popup_info.rule_list"
                :key="indexManjian"
                v-html="itemManjian"
              ></span>
            </div>
            <!-- 批发 -->
            <div
              class="wholesaleContentText"
              v-if="JSON.stringify(itemManPop.popup_info) != '{}' && (itemManPop.special_type == 5)"
            >
              <div v-for="(itemPifa,indexPifa) in itemManPop.popup_info.rule_list" :key="indexPifa">
                <span>
                  <span class="wholesaleContentText_buynum" v-html="itemPifa.b"></span>
                </span>
                <span v-html="itemPifa.m"></span>
              </div>
            </div>
            <!-- 会员价 -->
            <div
              class="wholesaleContentText"
              v-if="JSON.stringify(itemManPop.popup_info) != '{}' && ( itemManPop.special_type == 7)"
            >
              <div v-for="(itemPifa,indexPifa) in itemManPop.popup_info.rule_list" :key="indexPifa">
                <span v-html="itemPifa.name"></span>
                <span v-html="itemPifa.rebate_price"></span>
              </div>
            </div>

            <!-- 参团返现 -->
            <div
              class
              v-if="JSON.stringify(itemManPop.popup_info) != '{}' && itemManPop.type == 2 && itemManPop.special_type == 1 && itemManPop.popup_info_add.rule_list.length"
            >
              <div class="ServiceTimeLimitBox">
                <div class="ServiceTimeLimit W100">
                  <div class="timeLimit_reduce" v-if="itemManPop.tag !=''">
                    <span>{{ itemManPop.popup_info_add.name }}</span>
                  </div>
                </div>

                <div
                  v-if="itemManPop.popup_info_add.rule_list.length"
                  class="ServiceTimeLimitBox_text1"
                >
                  <div
                    v-for="(itemManPop,indexManPop) in itemManPop.popup_info_add.rule_list"
                    :key="indexManPop"
                  >
                    <span v-html="itemManPop"></span>
                  </div>
                </div>
                <div v-if="itemManPop.popup_info_add.info != ''" class="ServiceTimeLimitBox_text2">
                  <span>{{ itemManPop.popup_info_add.info}}</span>
                </div>
              </div>
            </div>

            <div
              class="TipContentTime"
              v-if="itemManPop.special_type == 0 || itemManPop.special_type == 1 || itemManPop.special_type == 4"
            >
              <span>{{huodongshijian}}</span>
              <span>{{ itemManPop.popup_info.start_time }}{{zhi}}{{itemManPop.popup_info.end_time}}</span>
              <!-- 限时购后添加的数据 -->
              <div v-if="itemManPop.special_type == 4 && itemManPop.type == 2">
                <div v-if="itemManPop.popup_info.hour_info.length" >
                  <div v-for="(itemTimePop,indexTimePop) in itemManPop.popup_info.hour_info" :key="indexTimePop">
                    <span style="display:inline-block">{{ itemTimePop.start_time }}</span>
                    <span style="display:inline-block">{{ zhi }}</span>
                    <span style="display:inline-block">{{ itemTimePop.end_time }}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="PoperContentBtn" @click="closeTimeLimitBtn">{{allData.wancheng}}</div>
        </div>
      </CustomPopup>
    </div>

    <div v-html='scriptValue'>
    </div>
    <div v-html='scriptValue2'>
    </div>
  
  </div>
</template>



<script>
//获取用户信息接口
// import {userInfo} from '../../api/indexPost'
// import "../../../static/js/rem.js";

// 引入jq
// import $ from "jquery";

// 引入弹出框
import CustomPopup from "../../components/CustomPopup/custompopup.vue";

// import { mapState, mapActions } from "vuex";

// 动态引入css
// import {CSS}  from '../../assets/colors'

import wxapi from '../../../static/js/wxapi.js'



export default {
  name: "Home",
  // 弹窗组件
  components: {
    CustomPopup
  },
  
  data() {
    let that = this;
    return {
      bigPic: '',
      isShowBigpic: false,
      modalWidth: 0,
      modalHeight: 0,
      baseLeft : 0,
      baseTop: 0,
      bodyWidth: document.body.clientWidth,
      ele: null, // 不能在这里设置， dom还没有生成
      winxinIcon:false,
      // 微信分享指导层
      wixinShareStatus: false,
      // 规格显示隐藏
      guigeTopFlg:true,
      
      scriptValue:'',
      scriptValue2:'',
      // 颜色
      theme:'#fe0000',
      // 页面标题
      pageTitle:'',
      // 页面meta关键词
      contentKey:'',
      // 页面meta 描述
      contentDesc:'',
      // 轮播图的配置
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        //循环
        loop: false,
        //设定初始化时slide的索引
        initialSlide: 0,
        //滑动速度
        speed: 800,
        //滑动方向
        direction: "horizontal",
        //小手掌抓取滑动
        grabCursor: true,
        //分页器设置
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "fraction"
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
      },
      // 放大轮播图配置
      swiperOptionBig: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        // notNextTick: true,
        //循环
        loop: false,
        //设定初始化时slide的索引
        initialSlide: 2,
        //滑动速度
        speed: 800,
        //滑动方向
        direction: "horizontal",
        //小手掌抓取滑动
        // grabCursor: true,
        // observer: true, //修改swiper自己或子元素时，自动初始化swiper
        // observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // // zoom: {
        //   maxRatio: 5, //最大倍数
        //   minRatio: 2, //最小倍数
        //   toggle: false, //不允许双击缩放，只允许手机端触摸缩放。
        //   containerClass: "amplification_swiper" //zoom container 类名
        // },
        // width: window.innerWidth,
        zoom : true,
      },

      // 视频分钟数
      video_minute: "00",
      // 视频秒数
      video_second: "30",
      // 默认顶部导航透明度
      flgOpacity: 0,
      // 会员价
      members_values: "会员价",
      // 自营背景色
      bgcColor: "linear-gradient(90deg ,#FF751B 0%,#FFA10B 100%)",
      // 销量
      sales: 900000,
      // 切换标题,规格,参数,默认显示标题
      info: "title",
      // 相关商品列表
      releatedShopList: [],

      // 默认右上角导航隐藏
      flgMenu: false,
      // 默认更多四个状态内容隐藏
      flgFourState: false,

      // 播放器显示
      videoStatus: false,
      // 微团购显示
      weiStatus: true,
      // 轮播图显示
      lunboStatus: true,
      // 图片隐藏
      picStatus: false,
      // 视频隐藏
      videoListStatus: false,
      // 详情规格参数,默认隐藏
      // topFixed: false,

      // 顶部,商品,详情,评价
      topText: 0,

      // 商品顶部的距离
      scrollTop: 1,
      // 详情距离顶部的距离
      scrollTopDetail: 1,

      // 是否点击了商品和详情
      ifStatus: true,
      // 是否点击了评价
      ifEvaluation: true,
      // 颜色值
      colorList: [],
      // 尺码值
      sizeList: [],
      // color颜色是否被选中,默认不被选中
      flgColor: false,
      // 规格弹窗购买数量
      changeNumbers: 1,

      // 点击放大轮播图,默认不显示放大效果
      amplificationFlg: false,
      // 判断点击是否放大图片,默认不放大
      imgFlg: false,
      // 放大的图片路径
      imgSrc: "https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/shoppingImg.png",
      // 手机号选择列表
      phoneList: [],
      // 手机号判断条件
      indexClass: 0,
      // 选择的手机号
      myPhone: 0,
      // 未选择手机号(0),已选择手机号(1),规格选择(2),三种状态选择
      phoneValue: 0,

      // 总数据数组
      allData: {},
      // 规格接口数据
      guigeData: {},

      // 轮播数据
      pro_pic_info: [],
      // 视频数据
      pro_mp4: "",
      // 价格是否显示
      pro_price_show: "",
      // 价格
      pro_price: "",
      // 满减tag
      fullRedName: "",
      // 满减标题
      fullRedTitle: "",
      // 更多可用商品
      gengduokeyongshangpin: "",
      //type为1是满减
      type: "",
      // special_type用来判断是批发还是专享
      special_type: "",
      // 满减数据
      popup_info: [],

      // 满减数组
      manjianArray: [],
      // 活动时间
      huodongshijian: "",
      // 至
      zhi: "",

      // 定义变量用来判断,点击了哪一个参数,让参数下加上横线
      indexFlg: 0,

      // 取出规格param_id
      guige_param_id: "",
      // 已选规格
      guigeName: [],
      // 已选规格
      guigeNameHY: [],
      // 判断立即购买的状态
      ifBuy: 0,
      // 判断分享图片是否显示
      ifFxPic: false,
      // 判断分享图片详情是否显示
      ifFxDetail: false,
      // 文章list
      doc_list_Json: {},
      // 默认传入文章接口的参数
      tag_id: 0,
      page: 1,
      // 判断文章标签是否选中的条件
      indexPro: 0,
      // 定义一个参数,用来判断文章接口是否加载
      articleStatus: 0,
      // 标签的page
      doc_page: 1,
      // 存储文章的JSON数据
      allArticleJson: {},
      // 右上角菜单
      menuList: [],
      // 判断用户是否登录
      zz_userid: 0,
      // 判断是否点击了右上角菜单
      flgMenuNum: 0,
      // 定义一个空数组,作为中转,用来拼接分页文章
      articleArr: [],
      // 判断活动是否开始
      activity_state: -1,
      // 结束时间
      end_time: 0,
      // 点击放大的商品图片路径
      shopImgSrc: "",
      // 定义一个参数,用来判断立即购买的状态(0:不能买,1:能买)
      phone_infoFlg: 0,
      // 规格的id
      guige_repeat: 0,
      // 优惠券的总数据
      preferData: {},
      // 优惠券接口需要传入的参数
      idsVar: 0,
      // 优惠弹窗的数据
      preferentialPop: {},
      // 分享海报的所有数据
      shareJson: {},
      // 复制链接的参数
      returnUrl: "",
      // 用来判断,数量是否限时
      numFlg: 0,
      // 判断是限时购还是微团购
      flgSatausGou: 0,
      icon_typeStatus: "",
      // 判断回到顶部按钮是否显示
      topDistance: 1,
      // 文章等标题的总宽度
      box_width: 0,
      // 屏幕的宽度
      window_width: 0,
      // 错误信息
      err_msg: "",
      // 组合数据
      guige_arr: {},
      // 判断按钮是否显示
      changePhoneStatus: 0,
      // 选则手机号数据
      phone_info_arr: [],
      phone_info_change: [],
      // 手机号内容
      phoneModel: "",
      // pro_id
      guige_pro_id: "",
      // 购物车接口返回数据
      shoppingCatList: {},
      // 色系值
      color_style: "",
      // 定义一个参数,用来判断文章接口是否请求失败
      articleRequire:true,
      shareInfo: '',
      // 用来判断,文章标签的总宽度是否再次加载
      window_width_value:0,
      // 判断是不是有会员价,有的话,显示问号
      MarkValue:false,
      // 判断是不是特殊用户名
      usernameOne:'',
      // 会员等级
      levelValue:'',
      // 页面滚动的距离,用来判断放大图片之后,回到原来的位置
      imgScrollTop:0,
      paramsValueJson:'',
      phoneId:0,
      // 短视频入口
      videoStatusEntrance:false,
      video_url:'',
      httpData: location.protocol+'//',
      // 短视频文字
      detail_text:''
    };
  },
  // 动态改变meta的值
  metaInfo(){
      return{
        meta: [
          { name: 'keyword', content: this.contentKey },
          { name: 'description', content: this.contentDesc }
        ]
      }
    },
  mounted() {
    // 点击文章等内容的图片放大
      // $(document).on('click','.contentDeatils img',function(){
      //   let url =  $(this).attr('src')
      //   that.openImg(url)
      // })

    let that = this,
      user_id = this.$cookies.get("zz_userid");
    // 获取 zz_userid判断是否登录
    if ((user_id != undefined || user_id != null) && user_id > 0) {
      this.zz_userid = user_id;
    } else {
      this.zz_userid = 0;
    }

    // 判断回到顶部按钮是否显示
    let scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    if (scrollTop == 0) {
      this.topDistance = 0;
    }

    var width = document.body.offsetWidth;
    var wdithpx = width / 2 - 37 / 2;

    //加载层-默认风格
    layui.use("layer", function() {
      layer.ready(function() {
        layer.load({
          shade: false,
          offset: ["50%", wdithpx]
        });
      });
    });
    // 调取详情页接口
    that.detailFun(0);
    // 调取购物车列表接口
    this.shoppingCatFun();
    // 导航菜单接口
    that.menuFun();

    // 微信分享
    wxapi.wxRegister(this.wxRegCallback,this.$F.username,this.$F.pro_id)

    that.moreStatusFun()
    that.UserOperate()

    // 短视频接口
    that.shortVideo()
    that.$previewRefresh()
  },
  methods: {

    moreStatusFun (){
      let that =this
        var SiteStatsSign =  this.$cookies.get("SiteStatsSignKey");
        if (!SiteStatsSign) {
          this.$cookies.set(
            "SiteStatsSignKey",
            hex_md5(this.$F.username + (new Date()).valueOf() + that.GetRandomNum(10000, 99999)),
            24 * 365
          );
            SiteStatsSign = this.$cookies.get("SiteStatsSignKey");
        }
        this.$F.Response({
            url: "Public/UserOperate.php",
            param:{
                username: this.$F.username,
                rid: 1,
                mobile: 1,
                type: 1,
                opt: 'ipv',
                SiteStatsSign: SiteStatsSign,
                t: Date.parse(new Date())
            },
            success: function (res) {
                typeof func === "function" && func(data);
            }
        })
    },
    GetRandomNum (Min, Max) {   
        var Range = Max - Min;
        var Rand = Math.random();
        // return Min + Math.round(Rand * Range);
        return Math.floor(Math.random() * (Max - Min) + Min) ;
    },

    // 复制链接
    onCopyUrl: function(e) {
      layer.msg("复制成功", { time: 1200 });
    },
    onErrorUrl: function(e) {
      layer.msg("复制失败", { time: 1200 });
    },

// 微信分享
    wxRegCallback (data) {
      // 用于微信JS-SDK回调
      this.shareInfo = data
      this.wxShareTimeline()
      this.wxShareAppMessage()
    },
    wxShareTimeline () {
      // 微信自定义分享到朋友圈
      let option = {
        title: this.shareInfo.title, // 分享标题, 请自行替换
        link: this.shareInfo.link, // 分享链接，根据自身项目决定是否需要split
        imgUrl: this.shareInfo.imgUrl, // 分享图标, 请自行替换，需要绝对路径
        success: () => {
          alert('分享成功')
        },
        error: () => {
          alert('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareTimeline(option)
    },
    wxShareAppMessage () {
      // 微信自定义分享给朋友
      let option = {
        title: this.shareInfo.title, // 分享标题, 请自行替换
        desc: this.shareInfo.desc, // 分享描述, 请自行替换
        link: this.shareInfo.link, // 分享链接，根据自身项目决定是否需要split
        imgUrl: this.shareInfo.imgUrl, // 分享图标, 请自行替换，需要绝对路径
        success: () => {
          alert('分享成功')
        },
        error: () => {
          alert('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option)
    },

    // 详情接口函数
    detailFun(param_id) {
      let that = this;
      // 获取页面链接
      let locationUrl = location.href
      // 定义存储参数的对象
      // let paramsValue = {
      //     username: this.$F.username,
      //     pro_id: this.$F.pro_id,
      //     param_id: param_id
      //     }
          let paramsValue = {
          username: this.$F.username,
          pro_id: this.$F.pro_id,
          param_id: param_id
          }
           that.paramsValueJson = paramsValue

      // 获取问号后面的值
      if(window.location.search!=''){
          let searchValue=window.location.search.substr(1)
          let markArr = searchValue.split('&')

          for(let i=0; i<markArr.length; i++){
            let markValue = markArr[i].split('=')
            let key = markValue[0]
            let value =markValue[1]
            paramsValue[markValue[0]] = value
          }
      }
      
      // 详情信息接口
      this.$F.Response({
        url: "mallorder/api/detail.php",
        param:paramsValue,
        complete: () => {
          layui.use("layer", function() {
            // 关闭loading
            layer.closeAll("loading");
          });
        },
        success: res => {
          // let res = JSON.parse(res)
          if (res.code == 200) {
            
            setTimeout(function() {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }, 300);
            setTimeout(function() {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }, 1000);
            let allDataValue = res.data
            for(let i=0; i<allDataValue.pro_contents.length; i++){
              if(allDataValue.pro_contents[i].type == 1){
                for(let j=0; j<allDataValue.pro_contents[i].content.length; j++){
                  let contentValue = allDataValue.pro_contents[i].content[j];
                  let contentValueDom = $('<div>'+contentValue+'</div>');
                  contentValueDom.find('img').each(function(i, dom){
                    dom = $(dom);
                    if(!dom.parent('a').length){
                      dom.attr({'preview':'2'});
                    }
                  });
                  contentValue = contentValueDom.html();
                  contentValueDom = null;
                  allDataValue.pro_contents[i].content[j] = contentValue.replace(/\\\'/g, "'");
                  allDataValue.pro_contents[i].content[j] = contentValue.replace(/<strong/g, "<span style='font-weight:bold'");
                  allDataValue.pro_contents[i].content[j] = contentValue.replace(/.gif"/g, '.gif" style="width:inhreit !important;" ');
                  // allDataValue.pro_contents[i].content[j] = contentValue.replace(/<img/g, "<img preview='2'");
                  // allDataValue.pro_contents[i].content[j] = contentValue.replace(/<a\b[^<>]*><img preview='2'\b[^<>]*\/><\/a>/g, /<a\b[^<>]*><img\b[^<>]*\/><\/a>/g);
                  // const reg = /<a\b[^<>]*><img\b[^<>]*\/><\/a>/g;
                }
              }
              if(allDataValue.pro_contents[i].type == 2){
                  let contentValue2 = allDataValue.pro_contents[i].content
                  allDataValue.pro_contents[i].content = contentValue2.replace(/<strong/g, "<span style='font-weight:bold'");
              }
            }
            
            allDataValue.conver_origina = []
            // setTimeout(function(){
              for(let i=0; i<allDataValue.pro_pic_info.length;i++){
                let winW = parseInt($(".contianer_top").width())
                let index = allDataValue.pro_pic_info[i].indexOf("?")
                if(index != -1){
                  let sub = allDataValue.pro_pic_info[i].slice(0,Number(index)+1)
                  // 接口返的分辨率是800*800
                  allDataValue.conver_origina[i] = sub+`x-oss-process=image/resize,m_mfit,h_${600},w_${600},limit_0`
                  // allDataValue.conver_origina[i] = allDataValue.pro_pic_info[i]
                  // 改成图片原尺寸，轮播图点击预览的时候显示
                  allDataValue.pro_pic_info[i] = allDataValue.pro_pic_info[i].slice(0,Number(index))
                }else{
                  allDataValue.conver_origina[i] = allDataValue.pro_pic_info[i]
                }
              }
            // },100)
            that.allData = allDataValue;
            // 特殊用户的username
            that.usernameOne = this.$F.username
            // 获取用户的等级
            if(res.data.active_module.length){
              let levelVal = res.data.active_module[0].popup_info.rule_list
              for(let i=0;i<levelVal.length;i++){
                if(levelVal[i].is_now_level == 1){
                    that.levelValue = levelVal[i].name
                }
              }
            }

            if (res.data.pro_contents.length > 0) {
              if (res.data.pro_contents[0].type == 5) {
                that.articleFun(0, 1);
              }
            }

            // let scriptVal = 'var _hmt = _hmt || [];(function() {var hm = document.createElement("script");hm.src = "https://hm.baidu.com/hm.js?c732b055ed9d41fec60dfef77580494f";var s = document.getElementsByTagName("script")[0];s.parentNode.insertBefore(hm, s);})();';
            // let scriptnew = document.createElement('script');
            // scriptnew.setAttribute('type','text/javascript');
            // $('head').append(scriptnew);
            // scriptnew.innerHTML = scriptVal

            // 往head动态添加内容
            // 创建script标签，执行script内容
            if(res.data.is_inlcude == 1){
                let script = document.createElement('script')
                script.type = 'text/javascript'
                let http = window.location.protocol

                script.src=http + '//' + document.domain +'/mallorder/js/'+this.$F.username+'_public.js?random='+Math.random()
                document.getElementsByTagName('body')[0].append(script)
            }else if(res.data.is_inlcude == 2 && res.data.wap_stat_code != ''){
                that.scriptValue = res.data.wap_stat_code
            }

            if(allDataValue.wap_online_code != ''){
              // $('body').append(allDataValue.wap_online_code)
              if(that.$F.username == 'shbeipai'){
                  let _bdhmProtocol = (("https:" == document.location.protocol) ? " https://" : " http://");
                  let code =unescape("%3Cscript src='" + _bdhmProtocol + "hm.baidu.com/h.js%3Ff3f46eb2e7f81ed633388a8842dc986e' type='text/javascript'%3E%3C/script%3E")
                  $('body').append(code)
              }else{
                  $('body').append(allDataValue.wap_online_code)
              }
              // let _bdhmProtocol = (("https:" == document.location.protocol) ? " https://" : " http://");
              // let script = document.createElement('script');
              //   script.type = 'text/javascript'
              //   script.src = _bdhmProtocol+'hm.baidu.com/h.js%3Ff3f46eb2e7f81ed633388a8842dc986e'
              // let code =unescape("%3Cscript src='" + _bdhmProtocol + "hm.baidu.com/h.js%3Ff3f46eb2e7f81ed633388a8842dc986e' type='text/javascript'%3E%3C/script%3E")
              // $('body').append(code)
              // var str = "aaabbbcccdddeeefff";
              // let str = code.match(/document.write(\S*)/)[1];
              // console.log(str)
            }
            

            // 判断有没有会员价
            for(let i=0; i<res.data.active_module.length; i++){
              if(res.data.active_module[i].special_type == 7){
                that.MarkValue = true
              }
            }
            // 动态改变title
            that.pageTitle = res.data.seo_info.title

            // setTimeout(function(){
            //   that.pageTitle = "123"
            // },1000)
            // 动态改变keyword
            that.contentKey = res.data.seo_info.keyword
            // 动态改变description
            that.contentDesc = res.data.seo_info.description

            // 更多可用商品
            that.gengduokeyongshangpin = res.data.gengduokeyongshangpin;
            // 活动时间
            that.huodongshijian = res.data.huodongshijian;
            // 至
            that.zhi = res.data.zhi;

            // 视频数据
            that.pro_mp4 = res.data.pro_mp4;
            if (res.data.pro_mp4 != "") {
              that.videoStatus = true;
            }
            // 放大之后的轮播图
            that.pro_pic_info = res.data.pro_pic_info
            if (that.allData.active_module.length != 0) {
              for (let i = 0; i < that.allData.active_module.length; i++) {
                if (
                  that.allData.active_module[i].type == 2 &&
                  that.allData.active_module[i].special_type == 4
                ) {
                  // 获取本地时间(时间戳)
                  let dateLocal = Date.parse(new Date());
                  // 获取接口返回的时间
                  let timeValue = that.allData.active_module[i].popup_info.end_time
                  var arrTime = timeValue.split(/[- : \/]/);
                  var newDate = new Date(arrTime[0], arrTime[1]-1, arrTime[2], arrTime[3], arrTime[4], arrTime[5]);
                  var newDateValue = Date.parse(newDate)
                  // 获取差值
                  let difference = parseInt(newDateValue) - parseInt(dateLocal);
                  that.end_time = that.allData.active_module[i].popup_info.end_time;

                  // 将时间戳转换为时间
                  var days = parseInt(Math.floor(difference / (1000 * 60 * 60 * 24)));
                  var hours = parseInt(
                    (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                  );
                  var minutes = parseInt(
                    (difference % (1000 * 60 * 60)) / (1000 * 60)
                  );
                  var seconds = (difference % (1000 * 60)) / 1000;
                  var JsonTime = {
                    days: days,
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                  };
                  that.allData.JsonTime = JsonTime;
                  // 活动状态,(0,一开始,1:未开始,2:已结束)
                  that.activity_state =
                    that.allData.active_module[i].activity_state;
                  that.flgSatausGou = 0; //限时购
                  that.getTimeFun();
                } else if (
                  that.allData.active_module[i].type == 2 &&
                  that.allData.active_module[i].special_type == 1
                ) {
                  that.activity_state =
                    that.allData.active_module[i].activity_state;
                  that.flgSatausGou = 1; //微团购
                  that.end_time =
                    that.allData.active_module[i].popup_info.end_time;
                }
              }
            }

            // 循环pro_contents给文章等导航加上参数用来判断时候点击过了
            if (that.allData.pro_contents.length != 0) {
              for (let i = 0; i < that.allData.pro_contents.length; i++) {
                if (i == 0) {
                  that.allData.pro_contents[i].numParam = 1;
                } else {
                  that.allData.pro_contents[i].numParam = 0;
                }
              }
            }

            // 循环输出已选规格
            if (that.allData.discount_module.length > 0) {
              for (let i = 0; i < that.allData.discount_module.length; i++) {
                if (that.allData.discount_module[i].type == 3) {
                  that.guigeNameHY =
                    that.allData.discount_module[i].param_name_info;
                }
              }
            }
            
            if(that.window_width_value == 0){
            setTimeout(function() {
              let box_width = that.$refs.params_detailTitle_box_id.clientWidth;
              let window_width = window.screen.width;
              that.box_width = parseInt(box_width);
              that.window_width = parseInt(window_width - 25);
            }, 400);
            }
            that.window_width_value = 1

            setTimeout(function(){
              $(".contentDeatils ul li p").css({'display':'inline'});
            },100)
            
            that.$previewRefresh()
          }else if(res.code == 70001){
            setTimeout(function() {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }, 300);
             // 获取url,并将&替换成|
            let urlValue = location.href;
            
            urlValue = urlValue.replace(/&/,'|')

            let hrefValue = res.href
            let hrefArr = hrefValue.split('&')
            let hrefLast = ''
            for(let i=0; i<hrefArr.length; i++){
              
              let arrValue = '';
              if(i!= hrefArr.length-1 && i!=1){
                arrValue = hrefArr[i]+"&"
              }else{
                arrValue = hrefArr[i]
              }
              if(i==1 &&i!= hrefArr.length-1){

                let flg = '&wxCurUrl='+urlValue
                flg = encodeURIComponent(flg)
                arrValue = arrValue+flg+'&'
              }else if(i == 1 && i== hrefArr.length-1){
                 let flg = '&wxCurUrl='+urlValue
                 flg = encodeURIComponent(flg)
                 arrValue = arrValue+flg
              }
              hrefLast = hrefLast+arrValue
            }
            window.location.href=hrefLast

          }else if(res.code == 70002){
            setTimeout(function() {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }, 300);
             setTimeout(function() {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }, 1000);
            window.location.href=res.href
          }else {
            setTimeout(function() {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }, 300);
             setTimeout(function() {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }, 1000);

            layui.use("layer", function() {
              layer.alert(res.msg, {
                icon: 0,
                skin: "layer-ext-moon"
              },function () {
                   location.href = res.data.link;
                }
              );
            });
          }
        },
        error: () => {
          setTimeout(function() {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
          }, 300);
           setTimeout(function() {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }, 1000);

          //弹出警示信息
          layui.use("layer", ()=> {
            layer.alert('请求失败', {
              icon: 0,
              skin: "layer-ext-moon"
            },()=> {
                   location.href = '/wap_'+ this.$F.username +'.html';
                });
          });
        }
      });


    },
    // 购物车接口
    shoppingCatFun() {
      let that = this;
      that.$F.Response({
        url: "mallorder/api/popup.php",
        param: {
          username: this.$F.username,
          pro_id: this.$F.pro_id,
          zz_userid: this.zz_userid,
          method: "cartinfo"
        },
        success: res => {
          if (res.code == 200) {
            that.shoppingCatList = res.data;
            // 调取颜色
            setTimeout(function() {
              that.colorFun(res.data.color_style);
            }, 300);
          } else {
            // layui.use("layer", function() {
            //   layer.alert(res.msg, {
            //     icon: 0,
            //     skin: "layer-ext-moon"
            //   });
            // });
          }
        },
        error: () => {
          let that = this
          //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert("请求失败", {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   },function () {
          //          location.href = that.allData.return_url;
          //       });
          // });
        }
      });
    },

    UserOperate(){
      let that = this
      that.$F.Response({
        url: "Public/UserOperate.php",
        param: {
          username: that.$F.username,
          rid: that.$F.pro_id,
          opt: "browse",
          type: 10,
          t:Date.parse(new Date())
        },
        success: res => {
          if (res.code == 200) {
          } else {
          }
        },
        error: () => {
        }
      });
    },

    // 获取时间方法
    getTimeFun() {
      let that = this;
      if(that.flgSatausGou == 0){
      setInterval(function() {
        for (let i = 0; i < that.allData.active_module.length; i++) {
          if (
            that.allData.active_module[i].type == 2 &&
            that.allData.active_module[i].special_type == 4
          ) {
            // 获取本地时间(时间戳)
            let dateLocal = Date.parse(new Date());
             // 获取接口返回的时间
            let timeValue = that.allData.active_module[i].popup_info.end_time
            var arrTime = timeValue.split(/[- : \/]/);
            var newDate = new Date(arrTime[0], arrTime[1]-1, arrTime[2], arrTime[3], arrTime[4], arrTime[5]);
            var newDateValue = Date.parse(newDate)
            // 获取差值
            let difference = parseInt(newDateValue) - parseInt(dateLocal);
            that.end_time = that.allData.active_module[i].popup_info.end_time;

            // 将时间戳转换为时间
            var days = parseInt(Math.floor(difference / (1000 * 60 * 60 * 24)));
            var hours = parseInt(
              (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            var minutes = parseInt(
              (difference % (1000 * 60 * 60)) / (1000 * 60)
            );
            var seconds = (difference % (1000 * 60)) / 1000;
            var JsonTime = {
              days: days,
              hours: hours,
              minutes: minutes,
              seconds: seconds
            };
            if (that.allData.JsonTime == undefined) {
              that.allData.JsonTime = JsonTime;
            } else {
              that.$set(that.allData, "JsonTime", JsonTime);
              that.$forceUpdate();
            }
          } else if (
            that.allData.active_module[i].type == 2 &&
            that.allData.active_module[i].special_type == 1
          ) {
            that.activity_state = that.allData.active_module[i].activity_state;
          }
        }
      }, 1000);
      }
    },

    // 右上角菜单导航接口封装
    menuFun() {
      let that = this;
      that.$F.Response({
        url: "mallorder/api/popup.php",
        param: {
          username: this.$F.username,
          pro_id: this.$F.pro_id,
          zz_userid: this.zz_userid,
          method: "toppopup"
        },
        success: res => {
          if (res.code == 200) {
            that.menuList = res.data;
            for (let i = 0; i < that.menuList.length; i++) {
              if (parseInt(that.menuList[i].icon_type) == 5) {
                that.icon_typeStatus = that.menuList[i].name;
              }
            }
          }else{
            setTimeout(function() {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }, 300);

            layui.use("layer", function() {
              layer.alert(res.msg, {
                icon: 0,
                skin: "layer-ext-moon"
              });
            });
          }
          
          
        },
        error: () => {
          // let that = this
          // //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert("请求失败", {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   },function () {
          //          location.href = that.allData.return_url;
          //       });
          // });
        }
      });
    },
    // 右上角导航,点击显示和隐藏,默认隐藏
    changeMenu() {
      this.flgMenu = !this.flgMenu;

      if (this.flgMenuNum == 0) {
        this.menuFun();
      }
      this.flgMenuNum++;
    },

    // 规格弹窗函数封装
    specificationsFun(pro_id, param_id) {
      //加载层-默认风格
      layui.use("layer", function() {
        layer.ready(function() {
          layer.load({
            shade: false
          });
        });
      });

      let that = this;
      that.$F.Response({
        url: "mallorder/api/specinfo.php",
        param: {
          username: this.$F.username,
          pro_id: this.$F.pro_id,
          channel_id: this.allData.channel_id
        },
        success: res => {
          if (res.code == 200) {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
            that.$refs.shoppingStatus.showCustom();

            that.guigeData = res;

            // 先判断是不是无规格商品
            if (res.spec_info.length) {
              // 组合数据
              let pro_specValue = res.pro_spec[param_id];

              that.guige_param_id = param_id;
              that.guige_arr = pro_specValue;

              // 判断组合数据是不是为undefined,防止paramid传错的情况出现
              if (pro_specValue != undefined) {
                let spec_info = res.spec_info;

                if (spec_info.length > 0) {
                  for (let j = 0; j < spec_info.length; j++) {
                    for (let k = 0; k < spec_info[j].spec.length; k++) {
                      // 先判断是否有默认规格,如果没有默认选择接口返回的规格
                      if (JSON.stringify(that.guigeData.pro_spec) != "{}") {
                        if (
                          that.guigeData.spec_info[j].spec[k].param_ids.indexOf(
                            param_id
                          ) != -1
                        ) {
                          that.guigeData.spec_info[j].spec[k].is_default = 1;
                        } else {
                          that.guigeData.spec_info[j].spec[k].is_default = 0;
                        }
                        that.spec_info = that.guigeData.spec_info;
                      } else {
                        that.spec_info = that.guigeData.spec_info;
                      }
                    }
                  }
                } else {
                  //请求购物车列表接口
                  // that.againRequest();
                }

                // 手机号
                that.phone_info_arr = res.phone_info;
                that.phone_info_change = res.phone_info;
                if(res.phone_info.length){
                  that.phoneId= res.phone_info[0].id
                }
                // 已选规格
                if (pro_specValue.name != undefined) {
                  that.guigeName = pro_specValue.name.split("#");
                }
                // 优惠金额
                that.guigeData.pro_price = pro_specValue.pro_price;
                // 金额
                that.guigeData.pro_original_price =
                  pro_specValue.pro_original_price;
                // 优惠方式
                that.guigeData.pro_tag = pro_specValue.pro_tag;
                // 是否能购买
                that.guigeData.is_buy = pro_specValue.is_buy;
                //  必须使用积分
                that.guigeData.jifen_must_num = pro_specValue.jifen_must_num;

                // 判断是否是批发组的情况,如果是组,不显示最小定量,只能加入购物车
                if (res.is_specia_wholesale == 1) {
                  that.changeNumbers = 1;
                } else {
                  // 购买数量默认是最小定量
                  that.changeNumbers = parseInt(that.guigeData.pro_small);
                }

                // 原价
                that.guigeData.pro_original_price_show =
                  pro_specValue.pro_original_price_show;
                // 折扣价
                that.guigeData.pro_price_show = pro_specValue.pro_price_show;
                // 限购数量
                that.restrict_num = pro_specValue.restrict_num;
                // 批发标签
                that.guigeData.wholesale_info = pro_specValue.wholesale_info;
                if (pro_specValue.is_buy == 0) {
                  that.ifBuy = 0;
                } else {
                  that.ifBuy = 1;
                }

                // 错误信息
                that.err_msg = pro_specValue.err_msg;
                // 图片
                if (pro_specValue.pro_pic != "") {
                  that.guigeData.pro_pic = pro_specValue.pro_pic;
                } else {
                  if (that.guigeData.pro_pic != "") {
                  } else {
                    that.guigeData.pro_pic = that.guigeData.pro_nopic;
                  }
                }
              } else {
                let yixuanValueLast = [];
                if (that.guigeData.spec_info.length) {
                  return;
                }
                // 这个循环取出选中的值
                for (let i = 0; i < that.guigeData.spec_info.length; i++) {
                  for (
                    let j = 0;
                    j < that.guigeData.spec_info[i].spec.length;
                    j++
                  ) {
                    if (that.guigeData.spec_info[i].spec[j].is_default == "1") {
                      yixuanValueLast = yixuanValueLast.concat(
                        that.guigeData.spec_info[i].spec[j].param_ids
                      );
                    }
                  }
                }
                // 手机号
                that.phone_info_arr = res.phone_info;
                that.phone_info_change = res.phone_info;
                if(res.phone_info.length){
                  that.phoneId= res.phone_info[0].id
                }
                // 输出重复项
                let repeat = "";
                if (yixuanValueLast.length > 1) {
                  var nary = yixuanValueLast.sort();
                  for (var i = 0; i < nary.length; i++) {
                    if (nary[i] == nary[i + 1]) {
                      repeat = nary[i];
                    }
                  }
                } else {
                  repeat = yixuanValueLast[0];
                }
                that.guige_param_id = repeat;
                // 取出对应pro_spec的值,
                let guigeLastValue = that.guigeData.pro_spec[repeat];
                that.guige_arr = guigeLastValue;

                // 价格
                that.guigeData.pro_original_price =
                  guigeLastValue.pro_original_price;
                // 优惠价
                that.guigeData.pro_price = guigeLastValue.pro_price;
                // 批发
                that.guigeData.pro_tag = guigeLastValue.pro_tag;
                // 规格名称
                that.guigeName = guigeLastValue.name.split("#");
                // is_buy
                that.guigeData.is_buy = guigeLastValue.is_buy;
                // 限购
                that.restrict_num = guigeLastValue.restrict_num;
                // 原价
                that.guigeData.pro_original_price_show =
                  guigeLastValue.pro_original_price_show;
                // 折扣价
                that.guigeData.pro_price_show = guigeLastValue.pro_price_show;
                // 必须使用积分
                that.guigeData.jifen_must_num = guigeLastValue.jifen_must_num;

                // 判断是否是批发组的情况,如果是组,不显示最小定量,只能加入购物车
                if (res.is_specia_wholesale == 1) {
                  that.changeNumbers = 1;
                } else {
                  // 购买数量默认是最小定量
                  that.changeNumbers = parseInt(that.guigeData.pro_small);
                }
                if (guigeLastValue.is_buy == 0) {
                  that.ifBuy = 0;
                } else {
                  that.ifBuy = 1;
                }
                // 批发标签
                that.guigeData.wholesale_info = guigeLastValue.wholesale_info;

                // 图片
                if (guigeLastValue.pro_pic != "") {
                  that.guigeData.pro_pic = guigeLastValue.pro_pic;
                  return;
                }
                if (that.guigeData.pro_pic != "") {
                  return;
                }
                that.guigeData.pro_pic = that.guigeData.pro_nopic;
              }
            } else {
              // 手机号
              that.phone_info_arr = res.phone_info;
              that.phone_info_change = res.phone_info;
              if(res.phone_info.length){
                  that.phoneId= res.phone_info[0].id
                }
              // 优惠金额
              that.guigeData.pro_price = res.pro_price;
              // 金额
              that.guigeData.pro_original_price = res.pro_original_price;
              // 优惠方式
              that.guigeData.pro_tag = res.pro_tag;
              // 是否能购买
              that.guigeData.is_buy = res.is_buy;
              // 必须使用积分
              that.guigeData.jifen_must_num = res.jifen_must_num;
              // 判断是否是批发组的情况,如果是组,不显示最小定量,只能加入购物车
              if (res.is_specia_wholesale == 1) {
                that.changeNumbers = 1;
              } else {
                // 购买数量默认是最小定量
                that.changeNumbers = res.pro_small;
              }

              if (res.is_buy == 0) {
                that.ifBuy = 0;
              } else {
                that.ifBuy = 1;
              }
              // 错误信息
              that.err_msg = res.err_msg;
              // 限购
              that.restrict_num = res.restrict_num;
              // 图片
              if (res.pro_pic != "") {
                that.guigeData.pro_pic = res.pro_pic;
              } else {
                if (that.guigeData.pro_pic != "") {
                } else {
                  that.guigeData.pro_pic = res.pro_nopic;
                }
              }
            }

            that.$previewRefresh()
          } else {
            //弹出警示信息
            layui.use("layer", function() {
              layer.alert(res.msg, {
                icon: 0,
                skin: "layer-ext-moon"
              });
            });
          }
        }
      });

      
    },

    // 规格分类选择
    changColorClick(index, indexSecond) {
      let that = this;
      // let yixuanValueLast = that.yixuanValue;
      let yixuanValueLast = [];
      // 这个循环改变选中的状态值
      for (let j = 0; j < that.guigeData.spec_info[index].spec.length; j++) {
        if (indexSecond == j) {
          that.guigeData.spec_info[index].spec[j].is_default = 1;
        } else {
          that.guigeData.spec_info[index].spec[j].is_default = 0;
        }
      }
      // 这个循环取出选中的值
      for (let i = 0; i < that.guigeData.spec_info.length; i++) {
        for (let j = 0; j < that.guigeData.spec_info[i].spec.length; j++) {
          if (that.guigeData.spec_info[i].spec[j].is_default == 1) {
            yixuanValueLast = yixuanValueLast.concat(
              that.guigeData.spec_info[i].spec[j].param_ids
            );
          }
        }
      }

      // 输出重复项
      let repeat = "";
      
      if (yixuanValueLast.length > 1) {
        var nary = yixuanValueLast.sort();
        var result = {};
       
    　　for(let i = 0; i < nary.length;i++) {
          if (!result[nary[i]]) {
            result[nary[i]] = 1
          } else {
            result[nary[i]]++
          }
        }

        let keys = Object.keys(result)
        let maxNum = 0,
            maxVal = '',
            length = 0,
            lengthBefore = 0;

        // 循环对象，取出value值最大的对应的key值
        for(let i = 0; i < keys.length;i++) {
          length++
          if(result[keys[i]] == 1){
            lengthBefore++
          }
          if (result[keys[i]] > maxNum) {
            maxNum = result[keys[i]];
            maxVal = keys[i]
          }
        }
        
        // 判断是否没有找到该规格
        if(lengthBefore == length){
          // 错误信息
          that.err_msg = that.guigeData.laguage_info.gaiguigebucunzai;
          that.ifBuy = 0;
          that.guigeTopFlg = false
          return false;
        }else{
          that.guigeTopFlg = true
        }
        repeat = maxVal
      } else {
        repeat = yixuanValueLast[0];
      }
      

      // 调取详情页接口
      that.detailFun(repeat);
      // 取出对应pro_spec的值,
      // let guigeLastValue = that.pro_specList[repeat];
      // 取出param_id
      that.guige_param_id = repeat;


      // 取出对应pro_spec的值,
      let guigeLastValue = that.guigeData.pro_spec[repeat];
      that.guige_arr = guigeLastValue;
      // 错误信息
      that.err_msg = guigeLastValue.err_msg;
      // 价格
      that.guigeData.pro_original_price = guigeLastValue.pro_original_price;
      // 优惠价
      that.guigeData.pro_price = guigeLastValue.pro_price;
      // 批发
      that.guigeData.pro_tag = guigeLastValue.pro_tag;
      // 规格名称
      that.guigeName = guigeLastValue.name.split("#");
      // is_buy
      that.guigeData.is_buy = guigeLastValue.is_buy;
      // 限购数量
      that.restrict_num = guigeLastValue.restrict_num;
      // 原价
      that.guigeData.pro_original_price_show =
        guigeLastValue.pro_original_price_show;
      // 折扣价
      that.guigeData.pro_price_show = guigeLastValue.pro_price_show;
      // 批发标签
      that.guigeData.wholesale_info = guigeLastValue.wholesale_info;
      //  必须使用积分
      that.guigeData.jifen_must_num = guigeLastValue.jifen_must_num;
      if (guigeLastValue.is_buy == 0) {
        that.ifBuy = 0;
      } else {
        that.ifBuy = 1;
      }
      that.changeNumbersFun(1)
      // 图片
      if (guigeLastValue.pro_pic != "") {
        that.guigeData.pro_pic = guigeLastValue.pro_pic;
        return;
      }
      if (that.guigeData.pro_pic != "") {
        return;
      }
      that.guigeData.pro_pic = that.guigeData.pro_nopic;
    },
    // 手机号搜索
    seachPhone() {
      let arr = [];
      let search_id = "";
      let phoneModelVal = this.phoneModel;
      for (let i = 0; i < this.phone_info_change.length; i++) {
        if (phoneModelVal == this.phone_info_change[i].phone) {
          search_id = this.phone_info_change[i].id;
        }
      }

      let Json = {
        id: search_id,
        phone: phoneModelVal
      };
      arr.push(Json);

      if (phoneModelVal != "") {
        if (
          JSON.stringify(this.phone_info_change).indexOf(
            JSON.stringify(Json)
          ) >= 0
        ) {
          this.phone_info_arr = arr;
          this.myPhone = phoneModelVal;
          this.indexClass = 0;
        } else {
          this.phone_info_arr = [];
        }
      }
      let inputValue = phoneModelVal.replace(/(^\s*)|(\s*$)/g, "").length;
      if (inputValue == 0) {
        this.phone_info_arr = this.phone_info_change;
        this.myPhone = this.phone_info_change[0].phone;
      }
    },

    // 跳转方法
    switchTo(path) {
      //$router中的path是当前的路由路径
      // this.$router.replace(path);
      this.ifEvaluation = false;

      let locationUrl = location.href

      this.$router.replace({
        path: path,
        query: {
          username: this.$F.username,
          pro_id: this.$F.pro_id,
          locationUrl:locationUrl
        }
      });

    },

    // 页面跳转
    switchToPage(link) {
      window.location.href = link;
    },

    getData() {
      let that = this;
      setTimeout(function() {
        let detailTitle = $('#params_detailTitle').offset();
        if (detailTitle == null) {
          return;
        }
        // 获取页面元素距离页面顶端的距离
        let detailTop = detailTitle['top']
        that.scrollTopDetail = detailTop;

      }, 200);
      window.addEventListener("scroll", this.handleScroll);
    },

    // 滚动函数
    handleScroll() {
      var that = this;
      that.flgMenu = false;
      that.flgFourState = false;
      // 判读是否点击了评价,点击了之后,不再走下面的判断
      if (!that.ifEvaluation) {
        return that.ifEvaluation;
      }

      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (scrollTop <= 0) {
        this.topDistance = 0;
      } else {
        this.topDistance = 1;
      }
      // 顶部透明度
      that.flgOpacity = scrollTop > 200 ? 1 : scrollTop * 0.005;

      // setTimeout(function() {
      let detailTitle = document.getElementById("params_detailTitle");
      if (detailTitle == null) {
        return;
      }
      // },100);

      setTimeout(function() {
        // 获取页面元素距离浏览器工作区顶端的距离
        var theDistance =
          $("#params_detailTitle").offset().top - $(window).scrollTop();
        if (theDistance < $(".voerTop_menu").height()) {
          // 让详情规格参数定位至顶部
          // that.topFixed = true;
          that.topText = 1;
        } else if (theDistance > $(".voerTop_menu").height()) {
          // 让详情规格参数位置复原
          // that.topFixed = false;
          that.topText = 0;
        }

        // 如果详情没有内容,则不用改变商品的选中样式
        if (that.allData.pro_contents.length == 0) {
          return;
        }

        let scrollTop = $(window).scrollTop();
        let scrollHeight = $(document).height();
        let windowHeight = $(window).height();
        if (scrollTop + windowHeight == scrollHeight) {
          that.topText = 1;
        }
      }, 100);

      // if (theDistance < $(".voerTop_menu").height()) {
      //   // 判断是点击了菜单导航还是滚动
      //   if (!that.ifStatus) {
      //     return that.ifStatus;
      //   }
      //   // that.topText = 1;
      // } else if (theDistance > $(".voerTop_menu").height()) {
      //   // 判断是点击了菜单导航还是滚动
      //   if (!that.ifStatus) {
      //     return that.ifStatus;
      //   }
      //   // that.topText = 0;
      // }
    },

    // 文章标签切换
    articleLabel(index, id, pro_Index) {
      this.indexPro = index;

      this.tag_id = id;
      this.page = 1;

      if (this.allArticleJson[id] != undefined) {
        this.doc_list_Json = this.allArticleJson[id];
      } else {
        this.articleFun(id, this.page);
      }
    },

    // 标题选中
    changeTitle(indexIfication, type) {
      this.indexFlg = indexIfication;

    //   // 每次标题选中,都回到顶部
    //   if (this.allData.pro_contents.length != 0) {
    //     for (let i = 0; i < this.allData.pro_contents.length; i++) {
    //       if (this.topFixed == true) {
    //           var scrollTopResult = this.scrollTopDetail;
    //           this.topText = 1;
    //           $("html,body").animate({ scrollTop: scrollTopResult - 51 }, 1);
    //       }
    //     }
    //   }

      if (type == 5) {
        if (this.articleStatus == 0) {
          this.articleFun(0, 1);
          return;
        }
        if(that.articleRequire){
          this.articleStatus = 1;
        }
      }
    },

    // 封装文章接口
    articleFun(tag_id, page) {
      let that = this;
      var width = document.body.offsetWidth;
      var wdithpx = width / 2 - 37 / 2;
      //加载层-默认风格
      layui.use("layer", function() {
        layer.load({
          shade: false,
          offset: ["50%", wdithpx]
        });
      });
      // 详情信息接口
      this.$F.Response({
        url: "mallorder/api/article.php",
        param: {
          username: this.$F.username,
          pro_id: this.$F.pro_id,
          tag_id: tag_id,
          page: page
        },
        success: res => {
          if (res.code == 200) {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });

            this.doc_list_Json = res.data;

            let allDataStatus = res.data;
            allDataStatus.tag_id = tag_id;

            if (this.allArticleJson[tag_id] != undefined) {
              // 中转数组
              this.articleArr = this.allArticleJson[tag_id].doc_list;
              let articleArr = this.articleArr;
              // 将数据拼接起来
              this.allArticleJson[tag_id].doc_list = articleArr.concat(
                res.data.doc_list
              );
              // 改变页数
              this.allArticleJson[tag_id].doc_page = res.data.doc_page;
              this.articleArr = articleArr;
              // 重新给对象赋值,渲染页面
              this.doc_list_Json = this.allArticleJson[tag_id];
            } else {
              this.allArticleJson[tag_id] = allDataStatus;
            }

            that.doc_page = res.data.doc_page;
            that.articleRequire = true;
          } else {
            that.articleRequire = false
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
            //弹出警示信息
            layui.use("layer", function() {
              layer.alert(res.msg, {
                icon: 0,
                skin: "layer-ext-moon"
              },function () {
                   that.articleFun()
                });
            });
          }
        },
        error: () => {
          let that = this
          layui.use("layer", function() {
            // 关闭loading
            layer.closeAll("loading");
          });
          //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert("请求失败", {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   },function () {
          //          location.href = that.allData.return_url;
          //       });
          // });
        }
      });
    },

    // 查看更多
    moreData(tag_id, doc_page) {
      let doc_pages = doc_page;
      doc_pages++;
      this.articleFun(tag_id, doc_pages);
    },

    // 规格选中
    changeSpecifications() {
      this.info = "specifications";
    },
    // 参数选中
    changeParams() {
      this.info = "parames";
    },

    // 全局事件,点击导航菜单之外的地方让菜单隐藏
    contianerClick() {
      // 让右上角菜单隐藏
      this.flgMenu = false;
      // 让更多隐藏
      this.flgFourState = false;
    },

    // 优惠弹窗
    speciClick(list) {
      this.$refs.CustomPopupRef.showCustom();

      this.preferentialPop = list;
    },
    // 关闭优惠弹窗
    closerButton() {
      this.$refs.CustomPopupRef.maskClickHidden();
    },

    // 服务弹窗
    tipClick() {
      this.$refs.CustomTipRef.showCustom();
    },
    // 关闭服务弹窗
    closerTipBtn() {
      this.$refs.CustomTipRef.maskClickHidden();
    },

    // 满减弹窗
    timeLimit(info) {
      this.$refs.CustomTimeLimit.showCustom();

      let manjianArr = [];
      manjianArr.push(info);

      this.manjianArray = manjianArr;
    },

    // 关闭满减弹窗
    closeTimeLimitBtn() {
      this.$refs.CustomTimeLimit.maskClickHidden();
    },

    // 分享接口
    shareFun() {
      let that = this
      var width = document.body.offsetWidth;
      var wdithpx = width / 2 - 37 / 2;
      //加载层-默认风格
      layui.use("layer", function() {
        layer.ready(function() {
          layer.load({
            shade: false,
            offset: ["50%", wdithpx]
          });
        });
      });

      this.$F.Response({
        url: "wap/shareAlert/ProDetailShare.php",
        param: {
          username: this.$F.username,
          zz_userid: that.zz_userid,
          pid: this.$F.pro_id
        },
        success: res => {
            if(res.code==200){
              
              // that.flgGuigeInfo = true;
                layui.use("layer", function() {
                  // 关闭loading
                  layer.closeAll("loading");
                });
                if(res.is_app == '0'){//弹出分享弹窗
                  that.shareJson = res;
                  that.ifFxPic = true;
                  that.returnUrl = res.returnUrl;
                  that.$refs.Customshare.PopupChildClick();
                  that.$refs.Customshare.showCustom();

                let isWeiXin = () => { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 }
                  if (isWeiXin()) {
                   this.winxinIcon = true
                  } else {
                    this.winxinIcon = false
                  }

                }else if(res.is_app == '1'){//IOS分享(不需要弹窗)
                  that.app_share_fn_ios(res.proname,res.share_link,res.brief,res.propic_url);
                }else if(res.is_app == '2'){//安卓分享(不需要弹窗)
                  that.app_share_fn_android(res.proname,res.share_link,res.brief,res.propic_url)
                }

          }else{
            layui.use("layer", function() {
            // 关闭loading
            layer.closeAll("loading");
          });
            layui.use("layer", function() {
            layer.alert(res.msg, {
              icon: 0,
              skin: "layer-ext-moon"
            });
          });
          }
        },
        error: (res) => {
          layui.use("layer", function() {
            // 关闭loading
            layer.closeAll("loading");
          });
        }
      });
    },
    // 分享弹窗
    shareClick() {
      // 分享接口
      this.shareFun();
    },
    // 关闭分享弹窗
    closeShare() {
      this.$refs.Customshare.maskClickHidden();
      this.$refs.Customshare.closePopupChild();
      this.ifFxPic = false;
    },

    // IOS分享
    app_share_fn_ios(title,url,con,pic){
        if(!con)con=title;
        var info = '{"title":"'+title+'","url":"'+url+'","con":"'+con+'","pic":"'+pic+'"}';
        normalShare(info);
    },
    // 安卓分享
    app_share_fn_android(title,url,con,pic){
      if(!con)con=title;
      window.android.share(title,con,pic,url);
    },

    // 保存图片
    operation(type) {
      if (type == 1) {
         if(this.shareJson.is_app == 0){//弹出图片,不是APP
            this.fenxiangDetailClick()
          }
      } else if (type == 2) {//复制链接
        // this.copy();
      }
    },

    // 分享弹窗详情
    fenxiangDetailClick() {
      this.$refs.CustomshareDetail.showCustom();
    },

    // 关闭分享弹窗详情
    closeShareDetail() {
      this.$refs.CustomshareDetail.maskClickHidden();
    },

    // 产品属性弹窗
    AttributeClick() {
      this.$refs.CustomAttributeRef.showCustom();
    },
    // 关闭产品属性弹窗
    closerAttributeBtn() {
      this.$refs.CustomAttributeRef.maskClickHidden();
    },

    // 批发弹窗
    wholesaleClick() {
      this.$refs.CustomWholesale.showCustom();
    },
    // 关闭批发弹窗
    closewholesaleBtn() {
      this.$refs.CustomWholesale.maskClickHidden();
    },
    // 优惠券弹窗
    vouchersClick(id) {
      // 优惠券接口
      this.receiveQuanFun(id, 0);
    },
    // 关闭优惠券弹窗
    closeVouchersBtn() {
      this.$refs.CustomVouchers.maskClickHidden();
    },
    // 优惠券接口
    receiveQuanFun(ids, type) {
      this.idsVar = ids;

      if (type == 0) {
        var width = document.body.offsetWidth;
        var wdithpx = width / 2 - 37 / 2;
        //加载层-默认风格
        layui.use("layer", function() {
          layer.ready(function() {
            layer.load({
              shade: false,
              offset: ["50%", wdithpx]
            });
          });
        });
      }

      let that = this;
      this.$F.Response({
        url: "mallorder/api/cart.php",
        param: {
          username: this.$F.username,
          method: "coupon",
          ids: ids
        },
        success: res => {
          if (res.code == 200) {
            if (type == 0) {
              setTimeout(function() {
                layui.use("layer", function() {
                  // 关闭loading
                  layer.closeAll("loading");
                });
              }, 300);
            }

            this.preferData = res;
            that.$refs.CustomVouchers.showCustom();

            // setTimeout(function(){
            // },200)
          } else {
            setTimeout(function() {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }, 300);
            layui.use("layer", function() {
              layer.alert(res.msg, {
                icon: 0,
                skin: "layer-ext-moon"
              });
            });
          }
        },
        error: () => {
          let that = this
          if (type == 0) {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
          }
          //弹出警示信息
          // layui.use("layer", function() {
          //   layer.alert("请求失败", {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   },function () {
          //          location.href = that.allData.return_url;
          //       });
          // });
        }
      });
    },

    // 立即领取
    receiveClick(id) {
      this.receiveQuan(id);
    },
    // 优惠券领取接口
    receiveQuan(coupon_id) {
      let that = this;
      this.$F.Response({
        url: "mallorder/api/cart.php",
        param: {
          username: this.$F.username,
          method: "getcoupon",
          coupon_id: coupon_id
        },
        // param: { username: this.$F.username },
        success: res => {
          if (res.code == 200) {
            //弹出警示信息
            layui.use("layer", function() {
              layer.msg(res.msg, { time: 1200 });
            });
            // 调用优惠券信息接口
            that.receiveQuanFun(this.idsVar, 1);
          } else {
            //弹出警示信息
            layui.use("layer", function() {
              layer.msg(res.msg, { time: 1200 });
            });
            // 调用优惠券信息接口
            that.receiveQuanFun(this.idsVar, 1);
          }
        }
      });
    },

    // 限时弹窗
    limitTimeAccording() {
      this.$refs.limitTimeAccording.showCustom();
    },
    // 关闭限时弹窗
    closelimitTimeAccording() {
      this.$refs.limitTimeAccording.maskClickHidden();
    },

    // 指定区域弹窗
    exclusiveClick() {
      this.$refs.CustomExclusive.showCustom();
    },
    // 关闭专享弹窗
    exclusiveBtn() {
      this.$refs.CustomExclusive.maskClickHidden();
    },

    // 专享弹窗
    wholesaleLastClick() {
      this.$refs.CustomWholesaleLast.showCustom();
    },
    closeWholesaleLastClick() {
      this.$refs.CustomWholesaleLast.maskClickHidden();
    },

    // 更多
    morenState() {
      this.flgFourState = !this.flgFourState;
    },

    // 视频播放
    playVideo() {
      var that = this;
      // 播放器隐藏,视频显示
      (that.videoStatus = false),
        // 微团购隐藏
        (that.weiStatus = false),
        // 轮播图隐藏
        (that.lunboStatus = false),
        // 图片隐藏
        (that.picStatus = false),
        // 视频显示
        (that.videoListStatus = true);

      setTimeout(function() {
        var vdo = document.getElementById("videoPlay");
        vdo.play();
        vdo.addEventListener(
          "ended",
          function() {
            // 播放器显示
            (that.videoStatus = true),
              // 微团购示
              (that.weiStatus = true),
              // 轮播图示
              (that.lunboStatus = true),
              // 图片隐藏
              (that.picStatus = false),
              // 视频显示
              (that.videoListStatus = false);
          },
          false
        );
      }, 300);
    },

    // 顶部菜单导航点击
    backShopp(index, path) {
      // if(index == 0){
      //   this.topText = index;
      // }

      this.ifStatus = false;

      if (index == 0) {
        $("html,body").animate({ scrollTop: 0 }, 500);
      } else if (index == 1) {
        var scrollTopResult = this.scrollTopDetail;

        $("html,body").animate({ scrollTop: scrollTopResult - 51 }, 500);
      } else if (index == 2) {
        // 获取页面链接
      let locationUrl = location.href
        this.$router.replace({
          path: path,
          query: {
            username: this.$F.username,
            pro_id: this.$F.pro_id,
            locationUrl:locationUrl
          }
        });
      }
    },

    // 规格选项
    shoppingStatusBtn() {
      this.$refs.shoppingStatus.showCustom();
    },
    // 规格弹窗
    preferentialClick(pro_id, param_id, type) {
      let that = this;
      if(type == 1){

       that.joinShoppCat(type)
      }else if(type == 2){
        that.specificationsFun(pro_id, param_id);
      }

      // if (type == 1) {
      //   this.numFlg = 1;
      // } else {
      //   this.numFlg = 0;
      // }
    },
    // 关闭规格弹窗
    closeShoppingStatusBtn() {
      this.$refs.shoppingStatus.maskClickHidden();
    },

    // 自定义数量变化方法
    changeNumbersFun(type1, type2) {
      let that = this;
      // 库存
      let kuncun;
      // 最大限购
      let restrict_num;
      // 判断组合数据中是否有数据
      if (JSON.stringify(that.guige_arr) != "{}") {
        kuncun = parseInt(that.guige_arr.pro_stock);
        restrict_num = parseInt(that.guige_arr.restrict_num);
      } else {
        kuncun = parseInt(that.guigeData.pro_stock);
        restrict_num = parseInt(that.guigeData.restrict_num);
      }
      // 最小定量
      let zuiSamll = parseInt(that.guigeData.pro_small);

      // 如果大于库存
      let max = parseInt(kuncun);
      let tmp_flag = 0;
      if (restrict_num > 0) {
        if (restrict_num < kuncun) {
          tmp_flag = 1;
          max = parseInt(restrict_num);
        }
      }
      // 加加调取方法
      if (type1 == 1) {
        if (parseInt(that.changeNumbers) > max) {
          if (tmp_flag == 1) {
            that.changeNumbers = max;
            if(that.activity_state ==2){
                that.ifBuy = 0;
            }
          } else {
            that.ifBuy = 0;
            that.err_msg = that.guigeData.laguage_info.kucunbuzu;
          }
          return;
        } else if (parseInt(that.changeNumbers) >= parseInt(zuiSamll) ) {
          if(that.activity_state ==2){
              that.ifBuy = 0;
            }else{
              that.ifBuy = 1;
            }
        }
      }

      // 减减调取方法
      if (type2 == 2) {
        let min = kuncun;
        let tmp_flag = 0;

        if (
          parseInt(that.changeNumbers) < parseInt(zuiSamll) &&
          that.guigeData.is_specia_wholesale != "1"
        ) {
          // that.changeNumbers = parseInt(zuiSamll);
          this.ifBuy = 0
            this.err_msg = this.guigeData.button_info.buy_define_name
          return false;
        } else if (
          that.guigeData.is_specia_wholesale == "1" &&
          that.changeNumbers < 1
        ) {
          that.changeNumbers = 1;
        } else if (parseInt(that.changeNumbers) <= max) {
          if(that.activity_state ==2){
              that.ifBuy = 0;
            }else{
              that.ifBuy = 1;
            }
        }
      }
    },

    // 规格弹出框数量减少
    reduceBuyNumbers() {
      this.changeNumbers = parseInt(this.changeNumbers) - 1;
      if (parseInt(this.changeNumbers) <= 1) {
        this.changeNumbers = 1;
      }
      this.changeNumbersFun(2, 2);
    },
    // 规格弹出框数量增加
    addBuyNumbers() {
      this.changeNumbers = parseInt(this.changeNumbers) + 1;

      this.changeNumbersFun(1, 1);
    },
    // 规格弹出框数量变化事件
    numberInput() {
      if (this.changeNumbers != "") {
        var re = /^\d+$/; //判断字符串是否为数字
        if (re.test(this.changeNumbers)) {
          if (
            parseInt(this.changeNumbers) <
              parseInt(this.guigeData.pro_small) &&
            this.guigeData.is_specia_wholesale != "1"
          ) {
            // this.changeNumbers = parseInt(this.guigeData.pro_small);
            // this.changeNumbers = 1;
            if(parseInt(this.changeNumbers)<=1){
              this.changeNumbers = 1
            }
            this.ifBuy = 0
            this.err_msg = this.guigeData.button_info.buy_define_name
            return false;
          } else if (
            this.guigeData.is_specia_wholesale == "1" &&
            parseInt(this.changeNumbers) <= 1
          ) {
            this.changeNumbers = 1;
          }
        } else {
          if (this.guigeData.is_specia_wholesale != "1") {
            this.changeNumbers = parseInt(that.guigeData.pro_small);
          } else {
            this.changeNumbers = 1;
          }
        }
        this.changeNumbersFun(1, 2);
      } else {
        this.ifBuy = 0;
        this.err_msg = this.guigeData.button_info.buy_define_name;
      }
    },
    // 规格弹窗失去焦点事件
    numberBlur() {
      if (this.changeNumbers == "") {
        if (this.guigeData.is_specia_wholesale != "1") {
          this.changeNumbers = parseInt(this.guigeData.pro_small);
        } else {
          this.changeNumbers = 1;
        }
        this.changeNumbersFun(1, 2);
      }
    },

    // 选择手机号
    changePhone() {
      this.$refs.CustomChangePhone.showMaskFull();
    },
    // 手机号选择之后弹窗
    colseChangePhone() {
      let that = this;
      let user_id = this.$cookies.get("zz_userid");
      if (!user_id || user_id == '') {
        location.href =
          "/dom/denglu.php?username=" +
          this.$F.username +
          "&wap=1&trespass=" +
          this.allData.trespass;
          return false;
      }
      that.$F.Response({
        url: "Ajax/PhoneBind.php?username=" + this.$F.username,
        param: {
          pro_id:this.$F.pro_id,
          user_user_id:user_id,
          use_phone_id:that.phoneId
        },
        success: res => {
          if (res.status == 200) {
            this.$refs.CustomChangePhone.maskCloseFull();

            // 把选择的手机号输出
            if (this.phone_info_arr.length == this.phone_info_change.length) {
              this.myPhone = this.guigeData.phone_info[this.indexClass].phone;
            }
            this.phoneValue = 1;
            this.phone_infoFlg = 1;
          } else {
              // 有不可选手机号
             let errorStatus = res.list
             let phone_info_arr = that.phone_info_arr
             for (let i = 0; i < phone_info_arr.length; i++) {
               for (let j = 0; j < errorStatus.length; j++) {
                 if (errorStatus[j].phone_id == phone_info_arr[i].id) {
                   phone_info_arr[i].use = 1
                 }
               }
             }
             that.phone_info_arr= phone_info_arr
 
             //弹出警示信息
             layui.use("layer", function() {
               layer.msg(res.msg, { time: 1200 });
             });
          }
        }
      });


      

    },
    // 手机号点击事件
    phoneCick(index,id) {
      this.indexClass = index;
      this.phoneId = id
    },

    // 点击轮播图
    swiperClick(index) {
      this.swiperOptionBig.initialSlide = parseInt(index);

      this.amplificationFlg = !this.amplificationFlg;
      this.lunboStatus = !this.lunboStatus;

      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
        this.imgScrollTop = scrollTop

        $('body').css({overflow:'hidden'})

      // 获取页面元素距离页面顶端的距离
        // that.scrollTopDetail = detailTitle.offsetTop;
      // }, 100);
    },
    // 关闭放大的轮播图
    swiperClickClose(index) {
      let that = this
      this.pro_pic_info = this.allData.pro_pic_info;

      this.swiperOption.initialSlide = parseInt(index);

      this.amplificationFlg = !this.amplificationFlg;
      this.lunboStatus = !this.lunboStatus;

      $('body').css({overflow:'visible'})
      $('html,body').animate({scrollTop:that.imgScrollTop}, 0);
    },
    // 点击放大图片
    openImg(imgUrl) {
      this.imgFlg = true;
      this.shopImgSrc = imgUrl;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
        this.imgScrollTop = scrollTop

        $('body').css({overflow:'hidden'})
    },
    // 关闭放大的图片
    colseImg() {
      let that = this
      that.imgFlg = false;
      that.shopImgSrc = "";
        $('body').css({overflow:'visible'})
       $('html,body').animate({scrollTop:that.imgScrollTop}, 0);
    },

    // 全部商品点击
    allShops() {
      location.href = this.allData.shop_info[0].link;
    },

    // 图册点击
    atlasClick(link) {
      location.href = link;
    },

    // 文章点击跳转
    docListClick(link) {
      location.href = link;
    },
    // 收藏接口
    collectionFun() {
      this.$F.Response({
        url: "mallorder/api/collect_add.php",
        // param: { username: "banish2015", pro_id: 15343769 },
        param: {
          username: this.$F.username,
          zz_userid: this.zz_userid,
          doc_id: this.allData.pro_id,
          title: this.allData.pro_name
        },
        success: res => {
          if (res.code == 200) {
            if (res.data == 1 || res.data == 2) {
              //取消收藏
              this.menuFun();
              if (this.icon_typeStatus == "收藏") {
                this.icon_typeStatus = "已收藏";
              } else if (this.icon_typeStatus == "已收藏") {
                this.icon_typeStatus = "收藏";
              }
            } else if (res.data == 3) {
              location.href =
                "/dom/denglu.php?username=" +
                this.$F.username +
                "&wap=1&trespass=" +
                this.allData.trespass;
            }
          } else {
            setTimeout(function() {
              layui.use("layer", function() {
                // 关闭loading
                layer.closeAll("loading");
              });
            }, 300);

            layui.use("layer", function() {
              layer.alert(res.msg, {
                icon: 0,
                skin: "layer-ext-moon"
              });
            });
          }
        },
        error: () => {
          let that = this
          setTimeout(function() {
            layui.use("layer", function() {
              // 关闭loading
              layer.closeAll("loading");
            });
          }, 300);

          // layui.use("layer", function() {
          //   layer.alert("请求失败", {
          //     icon: 0,
          //     skin: "layer-ext-moon"
          //   },function () {
          //          location.href = that.allData.return_url;
          //       });
          // });
        }
      });
    },

    // 收藏菜单点击
    fenxiangClick(link, type) {
      // 1（首页） 2（购物车） 3（我的） 4（分享） 5（收藏）
      if (type == 1 || type == 2 || type == 3) {
        location.href = link;
      } else if (type == 4) {
        this.shareFun();
      } else if (type == 5) {
        if (this.zz_userid == 0) {
          location.href =
            "/dom/denglu.php?username=" +
            this.$F.username +
            "&wap=1&trespass=" +
            this.allData.trespass;
        } else {
          this.collectionFun();
        }
      }
    },
    // 底部左侧icon点击跳转
    iconClick(type, link) {
      // 收藏
      if (type == 3) {
        if (this.zz_userid == 0) {
          location.href =
            "/dom/denglu.php?username=" +
            this.$F.username +
            "&wap=1&trespass=" +
            this.allData.trespass;
        } else {
          this.collectionFun();
        }
      } else if (type == 2) {
        //分享
        this.shareFun();
      } else {
        location.href = link;
      }
    },

    // 立即购买存cookie的函数
    getBuyCookie(type) {
      this.$cookies.set("is_liji", 1, 3600 * 24);
      this.$cookies.set("liji_pro_num", this.changeNumbers, 3600 * 24);
      if(this.guige_param_id == '' || this.guige_param_id == undefined || this.guige_param_id == null){
        this.guige_param_id = 0
      }

      // 弹窗中的立即购买
      if(type == 1){
        this.$cookies.set(
        "liji_param_pro",
        this.guigeData.pro_id + "_" + this.guige_param_id,
        3600 * 24
      );
      }else if(type==2){//详情页的立即购买
        this.$cookies.set(
        "liji_param_pro",
        this.allData.pro_id + "_" + this.allData.param_id,
        3600 * 24
      );
      }
      

      if (
        JSON.stringify(this.guigeData) != "{}" &&
        this.guigeData.phone_info.length
      ) {
        location.href =
          "/dom/sc_orderbuy.php?username=" +
          this.$F.username +
          "&wap=1&orderType=pro&tagPhone=" +
          this.myPhone+'&language_code=utf8';
      } else {
        location.href =
          "/dom/sc_orderbuy.php?username=" +
          this.$F.username +
          "&wap=1&orderType=pro"+'&language_code=utf8';
      }
    },

    // 立即购买
    immediatelyBuy(value, type) {
      let that = this;
      if (type == 1) {
        //点击了弹窗中的立即购买
        // 存入cookie
        that.getBuyCookie(1);
      } else if (type == 2) {
        //点击了详情页的立即购买
        if (value == "2") {
          //这个时候,点击立即购买弹出规格弹窗·
          that.preferentialClick(this.$F.pro_id,that.allData.param_id, 2);
        } else {
          // 存入cookie
          that.getBuyCookie(2);
        }
      }
    },
    // 加入购物车
    joinShoppCat(type) {
      let proId = '';
      if(type == 1){
        proId = this.allData.pro_id 
      }else{
        proId = this.guigeData.pro_id;
      }
      let num = 1;
      if(JSON.stringify(this.guigeData) != '{}'){
        if (this.guigeData.phone_info.length) {
        num = 1;
      } else {
        num = parseInt(this.changeNumbers);
      }
      }else{
        num = 1;
      }
         
      console.log(55)
      this.changeCookie(proId, this.guige_param_id, num);
      this.$refs.shoppingStatus.maskClickHidden();
    },

    // 加入购物车,获取cookie的方法
    changeCookie(proId, specId, proNum) {
      let that = this;
      // 读取cookie
      let gouwuche = this.$cookies.get(
          this.$F.username + "_gouwuche"
        ),
        user_id = this.$cookies.get("zz_userid"),
        data = {};

      var param_id = 0;

      if (specId) {
        param_id = specId;
      }

      var isUpdate = 0;
      var i = 0;
      var price_val = 0;
      console.log(3)
      if (gouwuche != null || gouwuche) {
        console.log(1)
        var aOrder = gouwuche;
        var carAllnum = 0;
        for (var key in aOrder) {
          carAllnum = carAllnum + parseInt(aOrder[key].num);
          if (key == proId + "_" + param_id) {
            aOrder[key] = {
              num: parseInt(aOrder[key].num) + parseInt(proNum),
              sort: aOrder[key].sort
            };
            var tmp_str = JSON.stringify(aOrder);
            that.$cookies.set(
              this.$F.username + "_gouwuche",
              tmp_str,
              3600 * 7
            );
            // 调取购物车图标的接口
            that.shoppingCatFun();
            //弹出加入成功信息
            layui.use("layer", function() {
              layer.msg(that.allData.yijiarugouwuche, {
                time: 1200
              });
            });
            isUpdate = 1;
            i = i + 1;
          } else {
            i = i + 1;
          }
        }
        // return false;
        if (!isUpdate) {
          // if (i > 100) {
          //   showAllzz($weisiteLa.shoppingCardYiMan + "£¡");
          //   return false;
          // }
          i = i + 1;
          aOrder[proId + "_" + param_id] = { num: parseInt(proNum), sort: i };
          var tmp_str = JSON.stringify(aOrder);
          this.$cookies.set(
            this.$F.username + "_gouwuche",
            tmp_str,
            3600 * 7
          );
          // 调取购物车图标的接口
          this.shoppingCatFun();
          //弹出加入成功信息
          layui.use("layer", function() {
            layer.msg(that.allData.yijiarugouwuche, {
              time: 1200
            });
          });

          // carAllnum = nCount.add(carAllnum, proNum);
        } else {
          // carAllnum = nCount.add(carAllnum, 1);
        }
        // updateShoppingCardNum(carAllnum);
      } else {
        console.log(2)
        //存入cookie
        var arrayObj = {};
        arrayObj[proId + "_" + param_id] = { num: parseInt(proNum), sort: i };
        var tmp_str = JSON.stringify(arrayObj);
        that.$cookies.set(
          this.$F.username + "_gouwuche",
          tmp_str,
          3600 * 7
        );
        // 调取购物车图标的接口
        that.shoppingCatFun();
        //弹出加入成功信息
        layui.use("layer", function() {
          layer.msg(that.allData.yijiarugouwuche, {
            time: 1200
          });
        });
      }
    },

    // 未登录点击立即领取
    qujiesuanClick() {
      if (this.zz_userid == 0) {
        location.href =
          "/dom/denglu.php?username=" +
          this.$F.username +
          "&wap=1&trespass=" +
          this.allData.trespass;
      }
    },
    // 门店配送链接
    storesClick() {
      location.href = this.allData.store_link;
    },
    // 搭配推荐
    collcationClick(link) {
      location.href = link;
    },
    // 推荐搭配单个商品
    commendClick(link) {
      location.href = link;
    },
    // 返回按钮
    backPage() {
      // if (this.allData.return_type == "1") {
      //   history.back();
      // } else {
      //   location.href = this.allData.return_url;
      // }
      if((this.$cookies.get("is_app") == 1) && (this.$cookies.get("ios") != 1)){
        window.android.goBack();
        return false;
      }
      if (document.referrer.length > 0) {
        history.back();
      } else {
        location.href = this.allData.return_url;
      }
    },
    // 相关产品跳转
    relatedProClick(link) {
      location.href = link;
    },
    // 关闭视频的按钮
    closeVideoClick() {
      this.videoStatus = true;
    },
    // 获取色系函数
    colorFun(value) {
      switch (value) {
        case "#469cb7":
          this.theme = 'color1'
          break;
        case "#b64d4a":
          this.theme = 'color2'
          break;
        case "#2f5e66":
          this.theme = 'color3'
          break;
        case "#77a0a6":
          this.theme = 'color4'
          break;
        case "#7f5935":
          this.theme = 'color5'
          break;
        case "#a5663b":
          this.theme = 'color6'
          break;
        case "#246b97":
          this.theme = 'color7'
          break;
        case "#4f803f":
          this.theme = 'color8'
          break;
        case "#941761":
          this.theme = 'color9'
          break;
        case "#201712":
          this.theme = 'color10'
          break;
        case "#73a65b":
          this.theme = 'color11'
          break;
        case "#ca528f":
          this.theme = 'color12'
          break;
        case "#1b919f":
          this.theme = 'color13'
          break;
        case "#dd627e":
          this.theme = 'color14'
          break;
        case "#40516d":
          this.theme = 'color15'
          break;
        case "#c78de2":
          this.theme = 'color16'
          break;
        case "#323e2a":
          this.theme = 'color17'
          break;
        case "#2e073e":
          this.theme = 'color18'
          break;
        case "#154d80":
          this.theme = 'color19'
          break;
        case "#65212e":
          this.theme = 'color20'
          break;
        case "#956652":
          this.theme = 'color21'
          break;
        case "#ff4500":
          this.theme = 'color22'
          break;
        case "#fea500":
          this.theme = 'color23'
          break;
        case "#fe0000":
          this.theme = 'color24'
          break;
        case "#1e90ff":
          this.theme = 'color25'
          break;
        case "#7f8000":
          this.theme = 'color26'
          break;
        case "#4682b4":
          this.theme = 'color27'
          break;
        case "#2e8a57":
          this.theme = 'color28'
          break;
        case "#000000":
          this.theme = 'color29'
          break;
        case "#4169e2":
          this.theme = 'color30'
          break;
        case "#ffd601":
          this.theme = 'color31'
          break;
        case "#4b0081":
          this.theme = 'color32'
          break;
        case "#8b4512":
          this.theme = 'color33'
          break;
        case "#ce8540":
          this.theme = 'color34'
          break;
        case "#d3691f":
          this.theme = 'color35'
          break;
        case "#483d8b":
          this.theme = 'color36'
          break;
        case "#ff1494":
          this.theme = 'color37'
          break;
        case "#566b30":
          this.theme = 'color38'
          break;
        case "#8c0000":
          this.theme = 'color39'
          break;
        case "#006401":
          this.theme = 'color40'
          break;
        case "#b8860b":
          this.theme = 'color41'
          break;
        case "#2f4f4e":
          this.theme = 'color42'
          break;
        case "#0000cc":
          this.theme = 'color43'
          break;
        case "#191971":
          this.theme = 'color44'
          break;
        case "#dc133d":
          this.theme = 'color45'
          break;
        case "#81007f":
          this.theme = 'color46'
          break;
      }
    },
    // 跳转购物车
    goShopping() {
      location.href = this.shoppingCatList.go_url;
    },
    //touch Start事件
    touchStartFun(){
    // 调取倒计时
          this.getTimeFun();
    },
    //  touch Move事件
    touchMoveFun(){
    // 调取倒计时
          this.getTimeFun();
    },
    //  touch End事件
    touchEndFun(){
      // 调取倒计时
      this.getTimeFun();
    },

    // 会员价点击弹出弹窗
    proTagCLick(){
      let that =this
      for(var i=0; i<that.allData.active_module.length;i++){
        if(that.allData.active_module[i].special_type == 7){
          that.timeLimit(that.allData.active_module[i])
        }
      }
    },

    // 微信分享
    wxShareStatus(){
      this.$refs.Customshare.maskClickHidden();
      this.$refs.Customshare.closePopupChild();
      this.ifFxPic = false;
      this.wixinShareStatus = true
      this.winxinIcon = false
    },


    // 短视频接口
    shortVideo(){
      let that = this;
      that.$F.Response({
        url: "eeeapi/Frontend/Shortvideo/proAppointShortVideo",
        // url: `${location.origin}/eeeapi/Frontend/Shortvideo/proAppointShortVideo`,
        param: {
          username: that.$F.username,
          pro_id: that.$F.pro_id,
          xcx: 0,
          real_host:location.host
          // real_host:'m.evyun.cn'
        },
        success: res => {
          if (res.code == 200) {
            if(res.data.video_id != 0){
              if(Object.keys(res.data.video_set).length && res.data.video_set.wap_detail_open == 1){
                  that.videoStatusEntrance = true
                  that.video_url = res.data.video_url
                  that.detail_text =res.data.video_set.detail_text
              }else{
                  that.videoStatusEntrance = false
              }
            }else{
              that.videoStatusEntrance = false
            }
          } else {
            that.videoStatusEntrance = false
          }
        },
        error: () => {
         that.videoStatusEntrance = false
        }
      });
    },
    // 关闭短视频入口
    closeVideoClick(){
      this.videoStatusEntrance = false
    },
    videoClick(){
      location.href= this.httpData+this.video_url
    }
    
  },

  created() {
    let that = this;
    that.flgMenu = false;
  },
  computed: {},
  watch: {
    allData: {
      handler(val, oldVal) {
        if (val != "{}") {
          let self = this;
          // 页面数据发生变化之后，加载滚动函数
          setTimeout(function() {
            self.getData();
          });
        }
      },
      deep: true
    }
  }
};
</script>


<style scoped lang="scss">
/*  引入外部scss文件 */
@import "../../../static/css/home.scss";
@import "../../../static/css/home.css";

@import "../../../static/css/color.scss"
</style>


// WEBPACK FOOTER //
// src/pages/Home/Home.vue